// @flow
import React from 'react';
import { THEME as theme } from 'GlobalStyles';
import { icon } from 'UI/constants/dimensions';
import { colors } from 'UI/res/colors';

const defaultIconSize = icon.default;
const defaultIconColor = colors.white;

type IconProps = {
  // eslint-disable-next-line react/no-unused-prop-types
  fill: string,
  size: number | string,
  ...
};

/*
  In order to add a svg you need to do the following steps. 
  1. Copy and paste the svg file exported from AdobeXD into the following website converter: https://react-svgr.com/playground/?icon=true
  2. Change the default function format into a constant arrow function. 
  3. Rename the constant into an explicit name describing the shape of the icon or it's implementation.
  4. Add the props type IconProps for regular icons. For advanced Icons add the type Object for custom props.
  5. Add the prop fill={fill} inside every path tag.
  6. Add the props width={size} height={size} on the svg tag.
  7. Fix any eslint issue.
  8. Double check its functionalities. Observe the other icons to guide yourself.
*/

export const NewInventoryItemNotificationIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <path
        fill={fill}
        d="M2.625 21A2.672 2.672 0 010 18.285V12.45a2.665 2.665 0 012.61-2.7h8.418a.75.75 0 01.75.75v7.8a2.661 2.661 0 01-2.61 2.7zm0-9.75A1.164 1.164 0 001.5 12.436V18.3a1.17 1.17 0 001.14 1.2h6.513a1.162 1.162 0 001.125-1.186V11.25z"
      />
      <path
        fill={fill}
        d="M8.25 16.5H4.5a.75.75 0 01-.75-.75V10.5a.75.75 0 01.75-.75h3.75a.75.75 0 01.75.75v5.25a.75.75 0 01-.75.75zm-3-1.5H7.5v-3.75H5.25z"
      />
      <path
        fill={fill}
        d="M6 11.25a.75.75 0 01-.75-.75V2.7A2.665 2.665 0 017.86 0h7.515A2.67 2.67 0 0118 2.715V9.57a.75.75 0 01-1.5 0V2.7a1.168 1.168 0 00-1.14-1.2H7.875A1.164 1.164 0 006.75 2.686V10.5a.75.75 0 01-.75.75z"
      />
      <path
        fill={fill}
        d="M13.5 6.75H9.75A.75.75 0 019 6V.75A.75.75 0 019.75 0h3.75a.75.75 0 01.75.75V6a.75.75 0 01-.75.75zm-3-1.5h2.25V1.5H10.5zM18.281 22.05a5.427 5.427 0 115.427-5.427 5.434 5.434 0 01-5.427 5.427zm0-9.354a3.927 3.927 0 103.927 3.927 3.932 3.932 0 00-3.927-3.923z"
      />
      <path
        fill={fill}
        d="M18.281 19.711a.75.75 0 01-.75-.75v-4.677a.75.75 0 111.5 0v4.677a.75.75 0 01-.75.75z"
      />
      <path fill={fill} d="M20.62 17.373h-4.677a.75.75 0 110-1.5h4.677a.75.75 0 010 1.5z" />
    </svg>
  );
};

export const StatusInventoryItemNotificationIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <path
        fill={fill}
        d="M2.625 21A2.672 2.672 0 010 18.285V12.45a2.665 2.665 0 012.61-2.7h8.418a.75.75 0 01.75.75v7.8a2.661 2.661 0 01-2.61 2.7zm0-9.75A1.164 1.164 0 001.5 12.436V18.3a1.17 1.17 0 001.14 1.2h6.513a1.162 1.162 0 001.125-1.186V11.25z"
      />
      <path
        fill={fill}
        d="M8.25 16.5H4.5a.75.75 0 01-.75-.75V10.5a.75.75 0 01.75-.75h3.75a.75.75 0 01.75.75v5.25a.75.75 0 01-.75.75zm-3-1.5H7.5v-3.75H5.25z"
      />
      <path
        fill={fill}
        d="M6 11.25a.75.75 0 01-.75-.75V2.7A2.665 2.665 0 017.86 0h7.515A2.67 2.67 0 0118 2.715V9.57a.75.75 0 01-1.5 0V2.7a1.168 1.168 0 00-1.14-1.2H7.875A1.164 1.164 0 006.75 2.686V10.5a.75.75 0 01-.75.75z"
      />
      <path
        fill={fill}
        d="M13.5 6.75H9.75A.75.75 0 019 6V.75A.75.75 0 019.75 0h3.75a.75.75 0 01.75.75V6a.75.75 0 01-.75.75zm-3-1.5h2.25V1.5H10.5zM13.714 21.615a.75.75 0 01-.75-.75v-2.849a.75.75 0 01.75-.75h2.849a.75.75 0 010 1.5h-2.1v2.1a.75.75 0 01-.749.749z"
      />
      <path
        fill={fill}
        d="M18.388 22.188a4.991 4.991 0 01-4.9-4.028.751.751 0 111.473-.289 3.484 3.484 0 006.716.458.75.75 0 111.42.486 4.99 4.99 0 01-4.713 3.373zM22.834 16.485h-2.851a.75.75 0 010-1.5h2.1v-2.1a.75.75 0 011.5 0v2.849a.75.75 0 01-.749.751z"
      />
      <path
        fill={fill}
        d="M22.318 16.485a.75.75 0 01-.735-.605 3.484 3.484 0 00-6.716-.458.75.75 0 01-1.42-.486 4.985 4.985 0 019.609.655.752.752 0 01-.592.881.91.91 0 01-.146.013z"
      />
    </svg>
  );
};

export const SignedFeeTabIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <path
        fill={fill}
        d="M17.25 24A6.75 6.75 0 1124 17.25 6.758 6.758 0 0117.25 24zm0-12a5.25 5.25 0 105.25 5.25A5.256 5.256 0 0017.25 12z"
      />
      <path
        fill={fill}
        d="M16.415 20.429a1.491 1.491 0 01-.9-.3 1.448 1.448 0 01-.158-.137l-1.5-1.5a.75.75 0 011.061-1.06l1.5 1.5 2.906-3.874a.75.75 0 111.2.9l-2.905 3.873a1.487 1.487 0 01-.989.585 1.54 1.54 0 01-.215.013zM8.25 15a5.25 5.25 0 010-10.5 5.252 5.252 0 014.957 3.526.75.75 0 11-1.416.493A3.753 3.753 0 008.25 6a3.75 3.75 0 000 7.5.75.75 0 010 1.5z"
      />
      <path
        fill={fill}
        d="M9.75 10.5h-1.5a.75.75 0 01-.75-.75v-1.5a.75.75 0 011.5 0V9h.75a.75.75 0 010 1.5z"
      />
      <path
        fill={fill}
        d="M7.5 21H2.25A2.253 2.253 0 010 18.75V2.25A2.252 2.252 0 012.25 0h10.629a2.262 2.262 0 011.591.66l2.871 2.871A2.266 2.266 0 0118 5.122V7.5a.75.75 0 01-1.5 0V5.122a.755.755 0 00-.22-.531L13.409 1.72a.753.753 0 00-.53-.22H2.25a.751.751 0 00-.75.75v16.5a.751.751 0 00.75.75H7.5a.75.75 0 010 1.5z"
      />
    </svg>
  );
};

export const PendingFeeTabIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 23.97 23.954" {...rest}>
      <path
        fill={fill}
        d="M12.004 20.203a8.259 8.259 0 01-8.25-8.25.75.75 0 011.5 0 6.75 6.75 0 106.75-6.75.75.75 0 010-1.5 8.25 8.25 0 010 16.5zM1.022 10.178a.727.727 0 01-.172-.02.749.749 0 01-.558-.9A12.133 12.133 0 011.45 6.222a.75.75 0 011.317.717 10.674 10.674 0 00-1.015 2.664.751.751 0 01-.73.575zM4.15 4.671a.75.75 0 01-.518-1.293 12.926 12.926 0 012.607-1.922.75.75 0 01.731 1.309 11.411 11.411 0 00-2.3 1.7.748.748 0 01-.52.206zM10.971 23.954h-.067a11.841 11.841 0 01-3.171-.727.75.75 0 11.533-1.4 10.383 10.383 0 002.77.636.75.75 0 01-.065 1.5zM5.075 21.637a.75.75 0 01-.456-.155 11.569 11.569 0 01-2.279-2.33.75.75 0 011.209-.887 10.056 10.056 0 001.984 2.027.75.75 0 01-.458 1.345zM1.363 16.503a.751.751 0 01-.705-.5 11.256 11.256 0 01-.654-3.193.751.751 0 011.5-.086 9.774 9.774 0 00.57 2.771.749.749 0 01-.7 1.006z"
      />
      <path
        fill={fill}
        d="M14.213 23.779a.75.75 0 01-.149-1.485 10.5 10.5 0 003.691-19.051 10.441 10.441 0 00-7.892-1.528.75.75 0 01-.3-1.47 12 12 0 0112.414 18.378 11.93 11.93 0 01-7.613 5.142.772.772 0 01-.151.014z"
      />
      <path
        fill={fill}
        d="M11.504 15.703a.75.75 0 01-.531-.219l-3-3a.75.75 0 011.061-1.06l2.389 2.389 3.981-5.31a.75.75 0 011.2.9l-4.5 6a.752.752 0 01-.547.3z"
      />
    </svg>
  );
};

export const PersonsIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 19.501 16.541" {...rest}>
      <defs>
        <style>
          {`.assign{fill:none;stroke:${fill};stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}`}
        </style>
      </defs>
      <path
        fill={fill}
        className="assign"
        d="M5.953 7.255a3.18 3.18 0 10-3.18-3.18 3.18 3.18 0 003.18 3.18zM.75 15.786a5.203 5.203 0 0110.406 0M11.814 1.409a3.18 3.18 0 110 5.33M12.391 10.714a5.209 5.209 0 016.359 5.075"
      />
    </svg>
  );
};

export const SMSIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" {...rest}>
      <path
        fill={fill}
        d="M4.375 20a.625.625 0 01-.625-.625V16.25H1.875A1.877 1.877 0 010 14.375v-12.5A1.877 1.877 0 011.875 0h16.25A1.877 1.877 0 0120 1.875v12.5a1.877 1.877 0 01-1.875 1.875H9.583L4.75 19.875a.621.621 0 01-.375.125zm-2.5-18.75a.625.625 0 00-.625.625v12.5a.626.626 0 00.625.625h2.5a.625.625 0 01.625.625v2.5l4-3A.623.623 0 019.375 15h8.75a.626.626 0 00.625-.625v-12.5a.626.626 0 00-.625-.625z"
      />
      <path
        fill={fill}
        d="M15.625 6.875H4.375a.625.625 0 010-1.25h11.25a.625.625 0 010 1.25zM13.125 10.625h-8.75a.625.625 0 010-1.25h8.75a.625.625 0 010 1.25z"
      />
    </svg>
  );
};

export const PhoneCallIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24.006 24.01" {...rest}>
      <path
        fill={fill}
        d="M14.806 24.01a5.257 5.257 0 01-2.827-.83l-.027-.019A41.186 41.186 0 01.844 12.052a5.227 5.227 0 01.7-6.56l.63-.63a2.252 2.252 0 013.181 0l2.651 2.652a2.253 2.253 0 010 3.186.751.751 0 000 1.06L12.249 16a.753.753 0 001.057 0 2.255 2.255 0 013.182 0l2.654 2.65a2.252 2.252 0 010 3.184l-.629.628a5.234 5.234 0 01-3.707 1.548zM3.764 5.7a.744.744 0 00-.529.219l-.631.63a3.727 3.727 0 00-.512 4.666 39.674 39.674 0 0010.7 10.7l.01.007.01.007a3.721 3.721 0 004.64-.532l.629-.629a.748.748 0 000-1.06l-2.653-2.651a.75.75 0 00-.53-.221.743.743 0 00-.53.22 2.256 2.256 0 01-3.182 0l-4.239-4.239a2.249 2.249 0 010-3.181.75.75 0 000-1.061L4.295 5.923a.748.748 0 00-.531-.223zM15.756 13.5a.75.75 0 01-.75-.75A3.755 3.755 0 0011.256 9a.75.75 0 010-1.5 5.256 5.256 0 015.25 5.25.75.75 0 01-.75.75z"
      />
      <path
        fill={fill}
        d="M19.506 13.5a.75.75 0 01-.75-.75 7.508 7.508 0 00-7.5-7.5.75.75 0 010-1.5 9.01 9.01 0 019 9 .75.75 0 01-.75.75z"
      />
      <path
        fill={fill}
        d="M23.256 13.5a.75.75 0 01-.75-.75A11.263 11.263 0 0011.256 1.5a.75.75 0 010-1.5 12.765 12.765 0 0112.75 12.75.75.75 0 01-.75.75z"
      />
    </svg>
  );
};

export const CareerbuilderIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" {...rest}>
      <defs>
        <style>{'.CareerbuilderIcon{fill:#fff;opacity:.5}'}</style>
      </defs>
      <g transform="translate(-370.286 -445.264)">
        <circle fill={fill} cx={14} cy={14} r={14} transform="translate(370.286 445.264)" />
        <path
          className="CareerbuilderIcon"
          d="M382.75 457.269a2.612 2.612 0 014.073 1h6.35a8.832 8.832 0 00-14.79-5.372zM381.802 459.283a2.6 2.6 0 01.66-1.731l-4.368-4.368a8.832 8.832 0 00-.217 12.132l4.457-4.457a2.6 2.6 0 01-.532-1.576zM386.832 460.265a2.608 2.608 0 01-4.231.9l-4.446 4.446a8.836 8.836 0 0015.041-5.341z"
        />
        <path
          className="CareerbuilderIcon"
          d="M382.75 457.269a2.612 2.612 0 014.073 1h6.35a8.832 8.832 0 00-14.79-5.372zM381.802 459.283a2.6 2.6 0 01.66-1.731l-4.368-4.368a8.832 8.832 0 00-.217 12.132l4.457-4.457a2.6 2.6 0 01-.532-1.576zM386.832 460.265a2.608 2.608 0 01-4.231.9l-4.446 4.446a8.836 8.836 0 0015.041-5.341z"
        />
        <g>
          <path
            className="CareerbuilderIcon"
            d="M382.75 457.269a2.612 2.612 0 014.073 1h6.35a8.832 8.832 0 00-14.79-5.372zM381.802 459.283a2.6 2.6 0 01.66-1.731l-4.368-4.368a8.832 8.832 0 00-.217 12.132l4.457-4.457a2.6 2.6 0 01-.532-1.576zM386.832 460.265a2.608 2.608 0 01-4.231.9l-4.446 4.446a8.836 8.836 0 0015.041-5.341z"
          />
        </g>
        <g>
          <path
            className="CareerbuilderIcon"
            d="M382.75 457.269a2.612 2.612 0 014.073 1h6.35a8.832 8.832 0 00-14.79-5.372zM381.802 459.283a2.6 2.6 0 01.66-1.731l-4.368-4.368a8.832 8.832 0 00-.217 12.132l4.457-4.457a2.6 2.6 0 01-.532-1.576zM386.832 460.265a2.608 2.608 0 01-4.231.9l-4.446 4.446a8.836 8.836 0 0015.041-5.341z"
          />
        </g>
        <g>
          <path
            className="CareerbuilderIcon"
            d="M382.75 457.269a2.612 2.612 0 014.073 1h6.35a8.832 8.832 0 00-14.79-5.372zM381.802 459.283a2.6 2.6 0 01.66-1.731l-4.368-4.368a8.832 8.832 0 00-.217 12.132l4.457-4.457a2.6 2.6 0 01-.532-1.576zM386.832 460.265a2.608 2.608 0 01-4.231.9l-4.446 4.446a8.836 8.836 0 0015.041-5.341z"
          />
        </g>
        <g>
          <path
            className="CareerbuilderIcon"
            d="M382.75 457.269a2.612 2.612 0 014.073 1h6.35a8.832 8.832 0 00-14.79-5.372zM381.802 459.283a2.6 2.6 0 01.66-1.731l-4.368-4.368a8.832 8.832 0 00-.217 12.132l4.457-4.457a2.6 2.6 0 01-.532-1.576zM386.832 460.265a2.608 2.608 0 01-4.231.9l-4.446 4.446a8.836 8.836 0 0015.041-5.341z"
          />
        </g>
      </g>
    </svg>
  );
};
export const IndeedIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" {...rest}>
      <defs>
        <style>{'.IndeedIcon{fill:#fff}'}</style>
      </defs>
      <g transform="translate(-612.413 -445.568)">
        <circle fill={fill} cx={14} cy={14} r={14} transform="translate(612.413 445.568)" />
        <path
          className="IndeedIcon"
          d="M625.321 460.137a4.955 4.955 0 002.843-.6v.419c0 2.114.005 4.229 0 6.343a4.132 4.132 0 01-.1.943 1.316 1.316 0 01-1.491 1.061 1.376 1.376 0 01-1.253-1.313c-.035-.536-.028-1.075-.029-1.612v-4.95c.005-.083.019-.17.03-.291zM628.823 456.251a2.128 2.128 0 01-2.186 2.169 2.156 2.156 0 01-2.2-2.17 2.189 2.189 0 012.166-2.178 2.144 2.144 0 012.22 2.179z"
        />
        <path
          className="IndeedIcon"
          d="M631.452 452.964a4.159 4.159 0 01-.395-.229 5.969 5.969 0 00-7.184 0 10.081 10.081 0 00-3.8 5.207c-.162.457-.3.922-.471 1.378a9.779 9.779 0 01.791-3.17 8.916 8.916 0 014.413-4.848 5.318 5.318 0 015.817.406 1.885 1.885 0 01.829 1.256z"
        />
      </g>
    </svg>
  );
};

export const GlassdoorIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 28.196 28.347" {...rest}>
      <path
        fill={fill}
        d="M28.195 14.262a14.1 14.1 0 11-13.9-14.26 14.134 14.134 0 0113.9 14.26zm-7.838-6.338a2.444 2.444 0 00-2.537-2.618c-2.34-.023-4.68-.01-7.021-.007-2.055 0-3.019.95-3.031 3.02a598.495 598.495 0 000 8.26c.016 2.158-.331 1.778 1.872 1.844.636.019.8-.228.8-.833-.024-2.928-.012-5.857-.009-8.786 0-.264.022-.528.037-.879zM7.862 20.394a2.474 2.474 0 002.616 2.683c2.389.021 4.778.016 7.166 0a2.611 2.611 0 002.781-2.829q.008-4.24 0-8.481c0-1.823 0-1.793-1.806-1.821-.667-.01-.844.206-.837.856.031 2.877.015 5.754.011 8.631 0 .291-.031.583-.051.958z"
      />
      <path
        fill="#fff"
        d="M20.357 7.921h-9.891c-.015.351-.037.615-.037.879 0 2.929-.015 5.858.009 8.786.005.605-.162.852-.8.833-2.2-.066-1.855.314-1.872-1.844a631.744 631.744 0 010-8.26c.012-2.069.976-3.017 3.031-3.02 2.34 0 4.681-.016 7.021.007a2.444 2.444 0 012.539 2.619z"
      />
      <path
        fill="#fff"
        d="M7.862 20.392h9.881c.021-.375.051-.666.051-.958 0-2.877.02-5.754-.011-8.631-.007-.65.17-.867.837-.856 1.806.028 1.806 0 1.806 1.821v8.481a2.611 2.611 0 01-2.783 2.828c-2.389.014-4.778.019-7.166 0a2.473 2.473 0 01-2.615-2.685z"
      />
    </svg>
  );
};

export const AnnouncementIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <path
        fill={fill}
        d="M23.249 23.25a.75.75 0 01-.75-.75v-.959l-5.159-1.719a7.468 7.468 0 01-5.28 2.429c-.077.002-.154.004-.231.004-3.845 0-7.056-2.942-7.42-6.743l-2.91-.97V15a.75.75 0 01-1.5 0V9a.75.75 0 011.5 0v.459l21-7V1.5a.75.75 0 011.5 0v21a.75.75 0 01-.75.75zM6.004 16.042a5.944 5.944 0 006.01 4.709 5.913 5.913 0 003.729-1.462l-9.739-3.247zm16.495 3.917V4.041l-21 7v1.919l15.814 5.271 5.186 1.728z"
      />
    </svg>
  );
};

export const OutlinedWarningIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 48 44.462" {...rest}>
      <path
        fill={fill}
        d="M43.501 44.462h-39a4.578 4.578 0 01-2.172-.551 4.439 4.439 0 01-2.151-2.662 4.369 4.369 0 01.386-3.381L20.055 2.304a4.526 4.526 0 017.886-.01l.006.01 19.5 35.573a4.421 4.421 0 01.554 2.139 4.48 4.48 0 01-4.5 4.446zm-19.5-41.5a1.514 1.514 0 00-1.312.767L3.196 39.29a1.454 1.454 0 00-.134 1.136 1.472 1.472 0 00.716.887 1.515 1.515 0 00.724.184h39a1.494 1.494 0 001.499-1.481 1.462 1.462 0 00-.188-.717l-19.5-35.574a1.507 1.507 0 00-1.312-.763z"
      />
      <path
        fill={fill}
        d="M24.747 36.31a1.484 1.484 0 01-1.352-.871 1.483 1.483 0 01.611-2.834 2.227 2.227 0 012.223 2.223 1.483 1.483 0 01-1.482 1.482zm-.741-.741z"
      />
      <path
        fill={fill}
        d="M23.255 36.31a1.483 1.483 0 01-1.482-1.482 2.227 2.227 0 012.225-2.223 1.483 1.483 0 01.611 2.834 1.484 1.484 0 01-1.354.871z"
      />
      <path
        fill={fill}
        d="M23.998 37.051a2.227 2.227 0 01-2.223-2.223 1.483 1.483 0 012.834-.611 1.483 1.483 0 01-.611 2.834z"
      />
      <path
        fill={fill}
        d="M24.006 37.051a1.483 1.483 0 01-.611-2.834 1.483 1.483 0 012.834.611 2.227 2.227 0 01-2.223 2.223zM24.001 29.637a1.483 1.483 0 01-1.482-1.482V14.819a1.482 1.482 0 112.964 0v13.339a1.483 1.483 0 01-1.482 1.479z"
      />
    </svg>
  );
};

export const NotesIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24.451 23.967" {...rest}>
      <path
        fill={fill}
        d="M11.475 23.968a.767.767 0 01-.541-.22.74.74 0 01-.21-.676l.765-3.745a.748.748 0 01.21-.383l7.782-7.62a2.972 2.972 0 014.131 0 2.886 2.886 0 01.033 4.036.113.113 0 01-.021.022l-7.783 7.62a.764.764 0 01-.391.2l-3.825.749a.764.764 0 01-.15.017zm1.469-4.124l-.494 2.421 2.473-.483 7.606-7.448a1.384 1.384 0 10-1.966-1.949zm10.139-4.993zM14.535 7.487H3.825a.75.75 0 110-1.5h10.71a.75.75 0 110 1.5zM14.535 11.981H3.825a.75.75 0 110-1.5h10.71a.75.75 0 110 1.5zM9.18 16.475H3.825a.75.75 0 110-1.5H9.18a.75.75 0 110 1.5z"
      />
      <path
        fill={fill}
        d="M7.65 20.971H2.299a2.275 2.275 0 01-2.295-2.247V2.247A2.275 2.275 0 012.299 0h10.842a2.338 2.338 0 011.623.658l2.929 2.868a2.212 2.212 0 01.672 1.588v3.125a.765.765 0 01-1.53 0V5.114a.733.733 0 00-.224-.528l-2.928-2.868a.778.778 0 00-.541-.22H2.299a.759.759 0 00-.765.749v16.477a.759.759 0 00.765.749h5.355a.75.75 0 110 1.5z"
      />
    </svg>
  );
};

export const AttachmentsIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <path
        fill={fill}
        d="M17.25 10.5A6.75 6.75 0 1024 17.25a6.758 6.758 0 00-6.75-6.75zm0 12a5.25 5.25 0 115.25-5.25 5.256 5.256 0 01-5.25 5.25z"
      />
      <path
        fill={fill}
        d="M15.53 17.03l.97-.969v4.189a.75.75 0 001.5 0v-4.189l.97.969a.75.75 0 101.06-1.06l-2.25-2.25a.751.751 0 00-1.06 0l-2.25 2.25a.75.75 0 101.06 1.06zM3.75 6a.75.75 0 000 1.5h10.5a.75.75 0 000-1.5zM9.75 10.5h-6a.75.75 0 000 1.5h6a.75.75 0 000-1.5zM7.5 15H3.75a.75.75 0 000 1.5H7.5a.75.75 0 000-1.5z"
      />
      <path
        fill={fill}
        d="M7.5 19.5H2.25a.751.751 0 01-.75-.75V2.25a.75.75 0 01.75-.75h10.629a.756.756 0 01.53.219l2.871 2.872a.755.755 0 01.22.53V7.5a.75.75 0 001.5 0V5.121a2.235 2.235 0 00-.659-1.59L14.47.658A2.269 2.269 0 0012.879 0H2.25A2.252 2.252 0 000 2.25v16.5A2.253 2.253 0 002.25 21H7.5a.75.75 0 000-1.5z"
      />
    </svg>
  );
};

export const AttachmentClipIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 10 16" {...rest}>
      <path
        fill={fill}
        d="M3.5 16A3.5 3.5 0 010 12.5V5a5 5 0 0110 0v5.5a.5.5 0 11-1 0V5a4 4 0 00-8 0v7.5a2.5 2.5 0 005 0V5a1 1 0 00-2 0v6.5a.5.5 0 01-1 0V5a2 2 0 014 0v7.5A3.5 3.5 0 013.5 16z"
      />
    </svg>
  );
};

export const ActivityLogIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24.48 23.968" {...rest}>
      <path
        fill={fill}
        d="M17.595 23.969a6.742 6.742 0 116.885-6.741 6.822 6.822 0 01-6.885 6.741zm0-11.984a5.244 5.244 0 105.355 5.243 5.306 5.306 0 00-5.355-5.244z"
      />
      <path
        fill={fill}
        d="M20.3 17.975h-2.7a.757.757 0 01-.765-.749v-2.649a.765.765 0 011.53 0v1.9h1.94a.75.75 0 110 1.5zM10.71 11.235H5.355a.75.75 0 110-1.5h5.355a.75.75 0 110 1.5zM8.415 14.98h-3.06a.75.75 0 110-1.5h3.06a.75.75 0 110 1.5zM8.415 18.724h-3.06a.75.75 0 110-1.5h3.06a.75.75 0 110 1.5z"
      />
      <path
        fill={fill}
        d="M9.945 23.967h-7.65A2.274 2.274 0 010 21.72V5.992a2.274 2.274 0 012.295-2.247h3.124a4.608 4.608 0 019.052 0h3.123a2.274 2.274 0 012.295 2.247v2.247a.765.765 0 01-1.53 0V5.992a.758.758 0 00-.765-.749h-3.825a.757.757 0 01-.765-.749 3.061 3.061 0 00-6.12 0 .758.758 0 01-.765.749H2.294a.759.759 0 00-.765.749v15.729a.759.759 0 00.765.749h7.65a.75.75 0 110 1.5z"
      />
      <path
        fill={fill}
        d="M9.944 5.243a1.124 1.124 0 111.147-1.123 1.137 1.137 0 01-1.147 1.123zm0-1.5a.375.375 0 10.383.375.379.379 0 00-.383-.373z"
      />
    </svg>
  );
};

export const FileIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 21 24" {...rest}>
      <path
        fill={fill}
        d="M16.807 24H2.25A2.253 2.253 0 010 21.75V2.25A2.252 2.252 0 012.25 0h10.629a2.269 2.269 0 011.591.658l5.871 5.873A2.235 2.235 0 0121 8.121v12.288a.75.75 0 01-1.5 0V8.121a.755.755 0 00-.22-.53l-5.871-5.872a.756.756 0 00-.53-.219H2.25a.75.75 0 00-.75.75v19.5a.751.751 0 00.75.75h14.557a.75.75 0 010 1.5z"
      />
      <path
        fill={fill}
        d="M20.25 9h-6A2.253 2.253 0 0112 6.75v-6a.75.75 0 011.5 0v6a.751.751 0 00.75.75h6a.75.75 0 010 1.5z"
      />
    </svg>
  );
};

export const DeleteIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 22.5 22.5" {...rest}>
      <path fill={fill} d="M21.75 4.5h-21a.75.75 0 110-1.5h21a.75.75 0 010 1.5z" />
      <path
        fill={fill}
        d="M15 4.5H7.5a.75.75 0 01-.75-.75v-1.5A2.252 2.252 0 019 0h4.5a2.253 2.253 0 012.25 2.25v1.5a.75.75 0 01-.75.75zM8.25 3h6v-.75a.751.751 0 00-.75-.75H9a.75.75 0 00-.75.75zM9 17.25a.75.75 0 01-.75-.75V9a.75.75 0 011.5 0v7.5a.75.75 0 01-.75.75zM13.5 17.25a.75.75 0 01-.75-.75V9a.75.75 0 011.5 0v7.5a.75.75 0 01-.75.75z"
      />
      <path
        fill={fill}
        d="M16.62 22.5H5.881a2.263 2.263 0 01-2.242-2.064L2.25 3.813A.751.751 0 013 3h16.5a.749.749 0 01.75.813l-1.388 16.624A2.262 2.262 0 0116.62 22.5zM3.815 4.5l1.319 15.812a.754.754 0 00.747.688H16.62a.754.754 0 00.748-.687L18.685 4.5z"
      />
    </svg>
  );
};

export const DownloadIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 19.5 24" {...rest}>
      <path
        fill={fill}
        d="M9.75.001a.75.75 0 01.75.75v15a.75.75 0 11-1.5 0v-15a.75.75 0 01.75-.75z"
      />
      <path
        fill={fill}
        d="M5.25 10.501a.744.744 0 01.53.22l3.97 3.968 3.97-3.969a.75.75 0 011.06 1.06l-4.5 4.5a.749.749 0 01-1.06 0l-4.5-4.5a.75.75 0 01.53-1.28z"
      />
      <path
        fill={fill}
        d="M3.75 3.751H6a.75.75 0 010 1.5H3.75a2.253 2.253 0 00-2.25 2.25V20.25a2.253 2.253 0 002.25 2.251h12a2.252 2.252 0 002.25-2.25V7.501a2.253 2.253 0 00-2.25-2.25h-2.252a.75.75 0 010-1.5h2.252a3.755 3.755 0 013.75 3.75V20.25a3.754 3.754 0 01-3.75 3.751h-12A3.755 3.755 0 010 20.251V7.501a3.755 3.755 0 013.75-3.75z"
      />
    </svg>
  );
};

export const SuccessIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <path
        fill={fill}
        d="M9.623 18a1.511 1.511 0 01-.315-.034 1.6 1.6 0 01-1.018-.775l-2.169-3.51a.83.83 0 01.162-1.059.616.616 0 01.929.184l2.178 3.526a.281.281 0 00.179.143.234.234 0 00.2-.046l.072-.08 6.97-10.059a.614.614 0 01.939-.126.834.834 0 01.11 1.067l-6.975 10.06a1.663 1.663 0 01-.378.4 1.445 1.445 0 01-.884.309z"
      />
      <path
        fill={fill}
        d="M12 24.001a12 12 0 1112-12 12.013 12.013 0 01-12 12zm0-22.5a10.5 10.5 0 1010.5 10.5A10.512 10.512 0 0012 1.501z"
      />
    </svg>
  );
};

export const CloseIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  const colorValue = fill.slice(1);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      {...rest}
    >
      <defs>
        <style>{`.CloseIcon${colorValue}{fill:${fill}}`}</style>
      </defs>
      <path
        className={`CloseIcon${colorValue}`}
        d="M12 24a12 12 0 1112-12 12.013 12.013 0 01-12 12zm0-22.5A10.5 10.5 0 1022.5 12 10.512 10.512 0 0012 1.5z"
      />
      <path
        className={`CloseIcon${colorValue}`}
        d="M15.274 16.655a.85.85 0 01-.607-.252l-3.035-3.034-3.035 3.034a.86.86 0 11-1.214-1.216l3.035-3.034L7.384 9.12a.858.858 0 111.213-1.213l3.035 3.034 3.032-3.034a.858.858 0 111.213 1.213l-3.034 3.035 3.038 3.032a.858.858 0 01-.608 1.465z"
      />
    </svg>
  );
};

export const CollapsibleArrowOpen = ({
  fill = colors.black,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...rest}
    >
      <g clipPath="url(#prefix__clip0)">
        <path
          d="M12 19.5a2.3 2.3 0 01-1.729-.78L.46 7.568a1.847 1.847 0 012.773-2.439l8.579 9.752a.25.25 0 00.376 0l8.579-9.752a1.848 1.848 0 112.773 2.439l-9.808 11.148A2.309 2.309 0 0112 19.5z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CollapsibleArrowClosed = ({
  fill = colors.black,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...rest}
    >
      <g clipPath="url(#prefix__clip0)">
        <path
          d="M12 4.5a2.3 2.3 0 011.729.78l9.811 11.15a1.847 1.847 0 11-2.773 2.439l-8.579-9.75a.25.25 0 00-.376 0l-8.579 9.752A1.847 1.847 0 11.46 16.432l9.808-11.148A2.31 2.31 0 0112 4.5z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CandidatesIcon = (props: Object) => {
  const { size = defaultIconSize, fill = theme.palette.grey[600] } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 23.997 24">
      <defs>
        <style>.a{fill}</style>
      </defs>
      <path
        fill={fill}
        className="a"
        d="M12.75,24a.75.75,0,0,1-.75-.75V9a.476.476,0,0,1,.01-.107.551.551,0,0,1,.011-.062.744.744,0,0,1,.489-.558l1.505-.509a5.019,5.019,0,0,1,4.407.6,3.519,3.519,0,0,0,3.084.419l1.5-.508a.75.75,0,0,1,.991.71v8.284a.749.749,0,0,1-.509.71l-1.5.509a5.019,5.019,0,0,1-4.407-.6,3.519,3.519,0,0,0-3.084-.419l-1,.336V23.25A.75.75,0,0,1,12.75,24Zm2.858-8.213a4.984,4.984,0,0,1,2.813.86,3.519,3.519,0,0,0,3.084.419l.99-.336v-6.7l-.509.172a5.02,5.02,0,0,1-4.406-.6,3.516,3.516,0,0,0-3.084-.42l-1,.338v6.7l.515-.174A4.957,4.957,0,0,1,15.608,15.787Z"
      />
      <path
        fill={fill}
        className="a"
        d="M5.25,7.5A3.75,3.75,0,1,1,9,3.75,3.754,3.754,0,0,1,5.25,7.5Zm0-6A2.25,2.25,0,1,0,7.5,3.75,2.252,2.252,0,0,0,5.25,1.5Z"
      />
      <path
        fill={fill}
        className="a"
        d="M3,24a.747.747,0,0,1-.746-.675L1.571,16.5H.75A.75.75,0,0,1,0,15.75v-3a5.25,5.25,0,0,1,9.847-2.537.749.749,0,0,1-.656,1.112h0a.751.751,0,0,1-.657-.388A3.751,3.751,0,0,0,1.5,12.75V15h.75A.747.747,0,0,1,3,15.675L3.679,22.5H6.822l.442-4.425A.746.746,0,0,1,8,17.4a.843.843,0,0,1,.086,0,.751.751,0,0,1,.666.821l-.51,5.1A.748.748,0,0,1,7.5,24Z"
      />
    </svg>
  );
};

export const NamesIcon = (props: Object) => {
  const { size = defaultIconSize, fill = theme.palette.grey[600], ...rest } = props;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <defs>
        <style>.a{fill}</style>
      </defs>
      <path
        fill={fill}
        className="a"
        d="M4.5 9a3 3 0 113-3 3 3 0 01-3 3zm0-4.5A1.5 1.5 0 106 6a1.5 1.5 0 00-1.5-1.5zM3 22.5a.751.751 0 01-.744-.657L1.588 16.5H.75a.75.75 0 01-.75-.75V13.5A4.505 4.505 0 014.5 9a.75.75 0 010 1.5 3 3 0 00-3 3V15h.75a.751.751 0 01.744.657L3.662 21H6a.75.75 0 010 1.5zM19.5 9a3 3 0 113-3 3 3 0 01-3 3zm0-4.5A1.5 1.5 0 1021 6a1.5 1.5 0 00-1.5-1.5zM18 22.5a.75.75 0 010-1.5h2.338l.668-5.343A.751.751 0 0121.75 15h.75v-1.5a3 3 0 00-3-3 .75.75 0 010-1.5 4.505 4.505 0 014.5 4.5v2.25a.75.75 0 01-.75.75h-.838l-.668 5.343A.751.751 0 0121 22.5zM12 7.5a3.75 3.75 0 113.75-3.75A3.754 3.754 0 0112 7.5zm0-6a2.25 2.25 0 102.25 2.25A2.252 2.252 0 0012 1.5z"
      />
      <path
        fill={fill}
        className="a"
        d="M9.75 24a.747.747 0 01-.75-.675L8.321 16.5H6.75a.75.75 0 01-.75-.75V13.5a6 6 0 0112 0v2.25a.75.75 0 01-.75.75h-1.571L15 23.325a.747.747 0 01-.75.675zm3.821-1.5l.683-6.825A.747.747 0 0115 15h1.5v-1.5a4.5 4.5 0 00-9 0V15H9a.747.747 0 01.746.675l.682 6.825z"
      />
    </svg>
  );
};

export const CompaniesIcon = (props: Object) => {
  const { size = defaultIconSize, fill = theme.palette.grey[600] } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <defs>
        <style>.a{fill}</style>
      </defs>
      <path
        fill={fill}
        className="a"
        d="M.75,24a.75.75,0,0,1,0-1.5H1.5V10.75A1.752,1.752,0,0,1,3.25,9h8.5a1.752,1.752,0,0,1,1.75,1.75v12.5a.75.75,0,0,1-.75.75ZM12,22.5V10.75a.25.25,0,0,0-.25-.25H3.25a.25.25,0,0,0-.25.25V12H4.5a.75.75,0,0,1,0,1.5H3v9H4.5V20.25a2.25,2.25,0,0,1,4.5,0V22.5Zm-4.5,0V20.25a.75.75,0,0,0-1.5,0V22.5Z"
      />
      <path
        fill={fill}
        className="a"
        d="M15.75,24a.75.75,0,0,1-.75-.75v-4.5a2.25,2.25,0,0,1,4.5,0V22.5H21V2.25a.75.75,0,0,0-.75-.75h-9a.75.75,0,0,0-.75.75V3h3.75a.75.75,0,0,1,0,1.5H10.5V6h.75a.75.75,0,0,1,0,1.5H9.75A.75.75,0,0,1,9,6.75V2.25A2.252,2.252,0,0,1,11.25,0h9A2.252,2.252,0,0,1,22.5,2.25V22.5h.75a.75.75,0,0,1,0,1.5ZM18,22.5V18.75a.75.75,0,0,0-1.5,0V22.5Z"
      />
    </svg>
  );
};

export const ArrowRight = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...rest}
    >
      <path
        d="M19.5 12a2.3 2.3 0 01-.78 1.729L7.568 23.54a1.848 1.848 0 01-2.439-2.773l9.752-8.579a.25.25 0 000-.376L5.129 3.233A1.847 1.847 0 017.568.46l11.148 9.808A2.308 2.308 0 0119.5 12z"
        fill={fill}
      />
    </svg>
  );
};

export const ArrowLeft = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...rest}
    >
      <g clipPath="url(#prefix__clip0)">
        <path
          d="M4.5 12a2.3 2.3 0 01.78-1.729L16.432.46a1.847 1.847 0 012.439 2.773l-9.752 8.579a.249.249 0 00-.063.291.25.25 0 00.063.085l9.752 8.579a1.846 1.846 0 11-2.439 2.773L5.284 13.732A2.31 2.31 0 014.5 12z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SearchBarIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fill={fill}
        d="M23.809,22.018l-6.649-6.65a9.453,9.453,0,1,0-1.8,1.8l6.649,6.65a1.289,1.289,0,0,0,1.8,0A1.275,1.275,0,0,0,23.809,22.018ZM2.8,9.673a6.874,6.874,0,1,1,6.874,6.876A6.875,6.875,0,0,1,2.8,9.673Z"
        transform="translate(-0.182 -0.185)"
      />
    </svg>
  );
};

export const FeeAgreementIcon = (props: Object) => {
  const {
    size = defaultIconSize,
    fill = colors.iconInactive,
    contrast = colors.middleGrey,
    ...rest
  } = props;
  return (
    <svg width={size} height={size} viewBox="0 0 30.025 30" {...rest}>
      <defs>
        <style>
          .a{contrast}.b{fill} {'.prefix__c{fill:#1a1c21}'}
        </style>
      </defs>
      <path fill="none" d="M.025 0h30v30h-30z" />
      <path
        d="M8.46 21.177a25.591 25.591 0 003.491 0s1.678 3.1 3.2 2.078 4.752-3.039 3.409-4.889-2.826-3.9-3.952-3.817-6.141.518-6.154 1.411-.475 5.06.006 5.217z"
        fill={contrast}
      />
      <path
        fill={fill}
        d="M3.685 27H2.25A2.253 2.253 0 010 24.75v-18A3.754 3.754 0 013.75 3h13.5a.75.75 0 010 1.5H3.75A2.252 2.252 0 001.5 6.75v18a.751.751 0 00.75.75h1.435a.75.75 0 010 1.5z"
      />
      <path
        fill={fill}
        d="M10.5 8.25H3.75a.75.75 0 010-1.5h6.75a.75.75 0 010 1.5zM10.5 11.25H3.75a.75.75 0 010-1.5h6.75a.75.75 0 010 1.5zM7.109 14.25H3.75a.75.75 0 010-1.5h3.359a.75.75 0 010 1.5zM15 13.5a.75.75 0 01-.75-.75V6a3 3 0 016 0v1.5a.75.75 0 01-.75.75h-3.75v4.5a.75.75 0 01-.75.75zm.75-6.75h3V6a1.5 1.5 0 10-3 0zM16.962 24.318a.75.75 0 01-.147-1.485l4.788-.958a.75.75 0 01.294 1.471l-4.787.954a.742.742 0 01-.148.018zM14.634 19.949a2.177 2.177 0 01-.883-.186 2.244 2.244 0 01-1.178-1.254 2.271 2.271 0 011.057-2.825l2.27-1.137a2.726 2.726 0 012.192-.125l4.651 1.832a.752.752 0 01-.551 1.4l-4.638-1.829a1.218 1.218 0 00-.975.063l-2.268 1.132a.77.77 0 00-.341.957.746.746 0 00.388.42.694.694 0 00.528.006l2.255-.954a.751.751 0 11.584 1.383l-2.26.954a2.187 2.187 0 01-.831.163z"
      />
      <path
        fill={fill}
        d="M13.47 26.964a1.57 1.57 0 01-1.125-.474l-2.8-2.134H8.2a.75.75 0 010-1.5h1.6a.749.749 0 01.455.153l3.045 2.326a.782.782 0 01.107.1.078.078 0 00.11.008l4.26-3.517a.092.092 0 00.023-.126l-2.312-2.566a.751.751 0 011.116-1l2.346 2.609a1.6 1.6 0 01-.208 2.244L14.477 26.6a1.574 1.574 0 01-1.007.364zM8.194 18.35a.75.75 0 01-.294-1.441l3.57-1.513a2.534 2.534 0 012.463.305l.274.222a.75.75 0 01-.943 1.166l-.247-.2a1.028 1.028 0 00-.976-.107L8.487 18.29a.742.742 0 01-.293.06z"
      />
      <path
        fill={fill}
        d="M7.112 25.108H6.75a.75.75 0 010-1.5h.3a.4.4 0 00.45-.368v-5.313a.381.381 0 00-.411-.322H6.75a.75.75 0 110-1.5h.3A1.887 1.887 0 019 17.882v5.4a1.906 1.906 0 01-1.888 1.826zM22.853 25.109A1.889 1.889 0 0121 23.329v-5.4a1.886 1.886 0 011.99-1.82h.26a.75.75 0 010 1.5h-.3a.411.411 0 00-.451.365v5.314a.38.38 0 00.409.322h.341a.75.75 0 010 1.5h-.3c-.031-.002-.064-.001-.096-.001z"
      />
    </svg>
  );
};

export const JobOrdersIcon = (props: Object) => {
  const { size = defaultIconSize, fill = theme.palette.grey[600] } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 21">
      <defs>
        <style>.a{fill}</style>
      </defs>
      <path
        fill={fill}
        className="a"
        d="M3.75,22.5A3.754,3.754,0,0,1,0,18.749v-9A3.754,3.754,0,0,1,3.75,6H7.5V3.749A2.252,2.252,0,0,1,9.75,1.5h4.5a2.252,2.252,0,0,1,2.25,2.25V6h3.75A3.754,3.754,0,0,1,24,9.749v9a3.754,3.754,0,0,1-3.75,3.75ZM20.25,21a2.252,2.252,0,0,0,2.25-2.25v-9A2.252,2.252,0,0,0,20.25,7.5H18V21ZM16.5,21V7.5h-9V21ZM3.75,7.5A2.252,2.252,0,0,0,1.5,9.749v9A2.252,2.252,0,0,0,3.75,21H6V7.5H3.75ZM15,6V3.749A.75.75,0,0,0,14.25,3H9.75a.75.75,0,0,0-.75.75V6Z"
        transform="translate(0 -1.499)"
      />
    </svg>
  );
};

export const DigIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} {...rest}>
      <g fill={fill}>
        <path d="M16.73 18.29a1 1 0 0 0-.17 2 29.16 29.16 0 0 1 3.77.52.25.25 0 0 1 0 .49A39.87 39.87 0 0 1 12 22a39.87 39.87 0 0 1-8.33-.71.25.25 0 0 1 0-.49 28.86 28.86 0 0 1 3.73-.52 1 1 0 0 0 .91-1.08 1 1 0 0 0-1.08-.91C0 18.9 0 20.4 0 21c0 2.67 8.32 3 12 3s12-.29 12-3c0-.6 0-2.1-7.27-2.71Z" />
        <path d="M12 21.6a1 1 0 0 0 .84-.46c2-3.06 6.52-10.53 6.52-13.78a7.36 7.36 0 0 0-14.72 0c0 3.25 4.56 10.72 6.52 13.78a1 1 0 0 0 .84.46ZM8.5 7a3.5 3.5 0 1 1 3.5 3.5A3.5 3.5 0 0 1 8.5 7Z" />
      </g>
    </svg>
  );
};

export const InventoryIconMap = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={size} width={size} {...rest}>
      <g fill={fill}>
        <path d="M13.27 11.87a.29.29 0 0 1-.17-.23.26.26 0 0 1 .16-.24 3.21 3.21 0 1 0-2.52 0 .26.26 0 0 1 .16.24.29.29 0 0 1-.17.23 4 4 0 0 0-2.68 3.74v3a.49.49 0 0 0 .49.49h.89a.25.25 0 0 1 .24.23l.33 4.22a.49.49 0 0 0 .49.45h3a.49.49 0 0 0 .49-.45l.36-4.26a.25.25 0 0 1 .24-.23h.89a.49.49 0 0 0 .49-.49v-3a4 4 0 0 0-2.69-3.7ZM4.63 5.64a.27.27 0 0 1-.17-.23.28.28 0 0 1 .15-.24 2.72 2.72 0 1 0-2.3 0 .27.27 0 0 1 .14.24.27.27 0 0 1-.17.23A3.45 3.45 0 0 0 0 8.89v1.48a.5.5 0 0 0 .14.35.52.52 0 0 0 .35.14h.82a.26.26 0 0 1 .25.22L2 14.87a.5.5 0 0 0 .49.44h2a.5.5 0 0 0 .5-.44l.42-3.79a.25.25 0 0 1 .24-.22h.82a.49.49 0 0 0 .49-.49V8.89a3.45 3.45 0 0 0-2.33-3.25ZM21.72 5.64a.27.27 0 0 1-.17-.23.26.26 0 0 1 .15-.24 2.72 2.72 0 1 0-2.31 0 .28.28 0 0 1 .15.24.27.27 0 0 1-.17.23 3.45 3.45 0 0 0-2.28 3.25v1.48a.48.48 0 0 0 .49.49h.82a.24.24 0 0 1 .24.22l.42 3.79a.5.5 0 0 0 .5.44h2a.5.5 0 0 0 .49-.44l.42-3.79a.26.26 0 0 1 .25-.22h.82a.49.49 0 0 0 .49-.49V8.89a3.45 3.45 0 0 0-2.31-3.25Z" />
      </g>
    </svg>
  );
};

export const CompanyIcon = (props: Object) => {
  const { size = defaultIconSize, fill = defaultIconColor } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 23.997 24">
      <defs> </defs>
      <g transform="translate(-1197 -458)">
        <path
          fill={fill}
          d="M.75,24a.75.75,0,0,1,0-1.5H1.5V10.75A1.752,1.752,0,0,1,3.25,9h8.5a1.752,1.752,0,0,1,1.75,1.75v12.5a.75.75,0,0,1-.75.75ZM12,22.5V10.75a.25.25,0,0,0-.25-.25H3.25a.25.25,0,0,0-.25.25V12H4.5a.75.75,0,0,1,0,1.5H3v9H4.5V20.25a2.25,2.25,0,0,1,4.5,0V22.5Zm-4.5,0V20.25a.75.75,0,0,0-1.5,0V22.5Z"
          transform="translate(1197 458)"
        />
        <path
          fill={fill}
          d="M15.75,24a.75.75,0,0,1-.75-.75v-4.5a2.25,2.25,0,0,1,4.5,0V22.5H21V2.25a.75.75,0,0,0-.75-.75h-9a.75.75,0,0,0-.75.75V3h3.75a.75.75,0,0,1,0,1.5H10.5V6h.75a.75.75,0,0,1,0,1.5H9.75A.75.75,0,0,1,9,6.75V2.25A2.252,2.252,0,0,1,11.25,0h9A2.252,2.252,0,0,1,22.5,2.25V22.5h.75a.75.75,0,0,1,0,1.5ZM18,22.5V18.75a.75.75,0,0,0-1.5,0V22.5Z"
          transform="translate(1197 458)"
        />
      </g>
    </svg>
  );
};

export const LinkedinIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 28.196 28.196" {...rest}>
      <path d="M14.1 0A14.1 14.1 0 110 14.1 14.1 14.1 0 0114.1 0z" fill={fill} />
      <path
        d="M21.719 16.209v5.812h-3.37v-5.423c0-1.362-.487-2.291-1.707-2.291a1.843 1.843 0 00-1.729 1.232 2.306 2.306 0 00-.112.821v5.661h-3.369s.045-9.184 0-10.135h3.37v1.436c-.007.011-.016.022-.022.033h.022v-.033a3.346 3.346 0 013.037-1.674c2.217 0 3.879 1.449 3.879 4.561zM7.907 7a1.756 1.756 0 10-.044 3.5h.022A1.757 1.757 0 107.907 7zM6.2 22.021h3.369V11.885H6.2z"
        fill="#f1f1f1"
      />
    </svg>
  );
};

export const CopyIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 22.998 24.65" {...rest}>
      <path
        fill={fill}
        d="M22.266 7.978l-3.352-3.352c-.157-.157-.526-.525-3.38-.73h-.027a.244.244 0 00-.026-.002h-.532V1.95a2.1 2.1 0 00-.531-1.286 2.254 2.254 0 00-1.6-.663H2.267a2.294 2.294 0 00-1.6.664A2.247 2.247 0 000 2.264v13.651a2.27 2.27 0 002.267 2.267h3.106a.724.724 0 00.37-.112v4.08a2.5 2.5 0 002.5 2.5h12.255a2.5 2.5 0 002.5-2.5V9.745a2.514 2.514 0 00-.732-1.767zm-1.061 1.06a1 1 0 01.293.707v.5h-5.267V5.464a9.6 9.6 0 011.681.28zM5.373 16.682H2.267a.768.768 0 01-.767-.767V2.264a.763.763 0 01.225-.542.8.8 0 01.542-.224h10.55a.754.754 0 01.495.174.669.669 0 01.137.276v1.946H8.244a2.5 2.5 0 00-2.5 2.5v10.4a.724.724 0 00-.371-.112zm15.125 6.468H8.244a1 1 0 01-1-1V6.395a1 1 0 011-1h6.487v5.6a.75.75 0 00.75.75h6.017v10.4a1 1 0 01-1 1.005z"
      />
    </svg>
  );
};

export const AssignIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 22.998 24.65" {...rest}>
      <defs>
        <style>
          {`.assign{fill:none;stroke:${fill};stroke-linecap:round;stroke-linejoin:round;stroke-width:1.2px}`}
        </style>
      </defs>
      <path
        className="assign"
        d="M.6 13.75a5.252 5.252 0 017.311-4.828M5.85 7.016a3.208 3.208 0 10-3.208-3.208A3.209 3.209 0 005.85 7.016zM11.971 15.116H9.055v2.917M18.162 15.686a4.334 4.334 0 01-8.353-.57M15.699 12.576h2.917V9.659M9.735 11.998a4.334 4.334 0 018.353.57"
      />
    </svg>
  );
};

export const AddNameIcon = (props: Object) => {
  const { size = defaultIconSize, fill = theme.palette.grey[600], ...rest } = props;

  return (
    <svg id="prefix__Regular" width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <defs>
        <style>
          {`.AddNameIcon{fill:none;stroke:${fill};stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}`}
        </style>
      </defs>
      <title>single-neutral-actions-star</title>
      <circle className="AddNameIcon" cx={6} cy={3.75} r={3} />
      <path
        className="AddNameIcon"
        d="M10.742 11.245A5.251 5.251 0 00.75 13.5v2.25H3l.75 7.5h4.5l.521-5.216M17.946 11.68L19.488 15h3a.735.735 0 01.518 1.283l-2.6 2.562 1.443 3.314a.786.786 0 01-1.119.982l-3.487-1.961-3.486 1.961a.786.786 0 01-1.12-.982l1.443-3.314-2.6-2.562A.734.734 0 0111.988 15h3l1.544-3.323a.8.8 0 011.414.003z"
      />
    </svg>
  );
};

export const DashboardIcon = (props: Object) => {
  const {
    size = defaultIconSize,
    fill = colors.iconInactive,
    contrast = colors.middleGrey
  } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 22.5 24">
      <g transform="translate(-0.999 1.422)">
        <rect fill={contrast} width="5" height="18.8" rx="2" transform="translate(5.6 0.578)" />
        <g transform="translate(-744.809 -410.818)">
          <path
            fill={fill}
            d="M768.306,414.527a2.264,2.264,0,0,0-.683-1.614l-3-2.88a2.247,2.247,0,0,0-1.568-.637h-15a2.252,2.252,0,0,0-2.25,2.25v19.5a2.253,2.253,0,0,0,2.25,2.25h18a2.253,2.253,0,0,0,2.25-2.25ZM766.058,431.9h-18a.752.752,0,0,1-.75-.75v-19.5a.751.751,0,0,1,.75-.75h15a.755.755,0,0,1,.528.216l2.995,2.879a.747.747,0,0,1,.227.536l0,16.619A.752.752,0,0,1,766.058,431.9Z"
          />
          <path
            fill={fill}
            d="M763.058,427.4h-11.25v-1.926l3.117-2.908a1.214,1.214,0,0,1,1.635-.007l.73.682a2.7,2.7,0,0,0,2.14.694,2.639,2.639,0,0,0,1.932-1.177l1.574-2.452a.75.75,0,0,0-1.262-.811l-1.568,2.443a1.146,1.146,0,0,1-.844.506,1.189,1.189,0,0,1-.953-.3l-.733-.685a2.711,2.711,0,0,0-3.668.007l-2.1,1.96V416.9a.75.75,0,0,0-1.5,0v11.25a.75.75,0,0,0,.75.75h12a.75.75,0,0,0,0-1.5Z"
          />
        </g>
      </g>
    </svg>
  );
};

export const BulkEmailIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = theme.palette.grey[600], ...rest } = props;

  return (
    <svg width={size} height={size} viewBox="0 0 24.502 23.237" {...rest}>
      <path
        fill={fill}
        d="M4.341 16.281a2.183 2.183 0 01-2.219-2.139v-9.25a2.183 2.183 0 012.219-2.139h14.6a2.183 2.183 0 012.22 2.139.6.6 0 11-1.2 0 .987.987 0 00-1.024-.943h-14.6a.986.986 0 00-1.023.943v9.249a.987.987 0 001.023.943.6.6 0 110 1.2z"
      />
      <path
        fill={fill}
        d="M2.22 13.527A2.183 2.183 0 010 11.388V2.14A2.184 2.184 0 012.22 0h14.6a2.184 2.184 0 012.22 2.14.6.6 0 01-1.2 0 .987.987 0 00-1.024-.944h-14.6a.987.987 0 00-1.024.944v9.249a.987.987 0 001.024.943.6.6 0 110 1.2z"
      />
      <path
        fill={fill}
        d="M5.951 18.913a1.818 1.818 0 01-1.816-1.817V7.338a1.811 1.811 0 01.43-1.173.308.308 0 01.031-.036 1.81 1.81 0 011.355-.608h15.857a1.821 1.821 0 011.816 1.817v3.4a.6.6 0 11-1.2 0V7.47l-7.094 4.892a2.581 2.581 0 01-2.9 0L5.33 7.47v9.623a.62.62 0 00.621.621h6.01a.6.6 0 110 1.2zm7.154-7.536a1.354 1.354 0 001.545 0l6.756-4.66H6.347zM21.07 22.714a1.254 1.254 0 01-.777-.48l-.428-.572-.795.544a1.263 1.263 0 01-1.971-1.044v-1.463h-1.732a1.26 1.26 0 01-.668-2.329l7.373-4.606a1.264 1.264 0 011.357.012l.01.006.029.02h.006a1.267 1.267 0 01.334.357 1.24 1.24 0 01.168.9l-1.434 7.64a1.263 1.263 0 01-1.238 1.03 1.315 1.315 0 01-.234-.015zm.178-1.2c.076.033.113 0 .117-.028l1.229-6.532-3.148 4.151zm-2.953-.353a.063.063 0 00.064.066l.787-.527-.754-1h-.1zm-2.961-2.78c-.027.094 0 .123.033.123h3.031l2.943-3.875z"
      />
    </svg>
  );
};

export const DashboardBulkEmailIcon = ({
  size = defaultIconSize,
  fill = theme.palette.grey[600],
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 23 22" {...rest}>
      <path
        fill={fill}
        d="M8.248 15.321h-3.75v-1.94l2.469-2.469a.768.768 0 011.061 0l.582.581a2.248 2.248 0 003.519-.435l.358-.6a.75.75 0 10-1.287-.77l-.359.6a.7.7 0 01-.111.141.741.741 0 01-.53.22.748.748 0 01-.53-.219l-.582-.581a2.235 2.235 0 00-1.59-.66 2.24 2.24 0 00-1.591.66l-1.408 1.409V7.069a.75.75 0 00-1.5 0v9a.75.75 0 00.75.75h4.5a.75.75 0 000-1.5z"
      />
      <path
        fill={fill}
        d="M7.5 20.125H2.25a.763.763 0 01-.75-.774V2.322a.763.763 0 01.75-.774h10.628a.748.748 0 01.531.227l2.871 2.964a.789.789 0 01.22.546l.091 5.552a.75.75 0 101.5 0L18 5.285a2.349 2.349 0 00-.659-1.641L14.469.68a2.2 2.2 0 00-1.59-.68H2.25A2.29 2.29 0 000 2.322v17.026a2.289 2.289 0 002.25 2.322H7.5a.774.774 0 000-1.548z"
      />
      <path
        fill={fill}
        d="M20.75 22h-7.5A2.253 2.253 0 0111 19.75v-4.5A2.252 2.252 0 0113.25 13h7.5A2.253 2.253 0 0123 15.25v4.5A2.253 2.253 0 0120.75 22zm-7.5-7.5a.75.75 0 00-.75.75v4.5a.751.751 0 00.75.75h7.5a.752.752 0 00.75-.75v-4.5a.751.751 0 00-.75-.75z"
      />
      <path
        fill={fill}
        d="M17 19a.748.748 0 01-.372-.1l-5.25-3a.75.75 0 01.744-1.3L17 17.386l4.878-2.786a.75.75 0 01.744 1.3l-5.25 3A.748.748 0 0117 19z"
      />
    </svg>
  );
};

export const SendBulkActionIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = theme.palette.grey[600], ...rest } = props;

  return (
    <svg width={size} height={size} viewBox="0 0 23.089 22.479" {...rest}>
      <path
        d="M2.252 22.479A2.251 2.251 0 01.287 19.13l4.833-7.9L.287 3.348A2.251 2.251 0 011.153.286a2.25 2.25 0 012.09-.054l19.022 9.663a1.506 1.506 0 01.811 1.222.734.734 0 01.01.115.465.465 0 01-.006.075 1.462 1.462 0 01-.157.606 1.5 1.5 0 01-.656.656L3.255 22.238a2.26 2.26 0 01-1.003.241zm-.671-2.591a.751.751 0 001 1.013l17.533-8.919H6.42zm18.53-9.406L2.575 1.574a.736.736 0 00-.323-.074.751.751 0 00-.658 1.112l4.825 7.87z"
        fill={fill}
      />
    </svg>
  );
};

export const NewBulkEmailIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = theme.palette.grey[600], ...rest } = props;

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <defs>
        <style>{`.prefix__NewBulkEmail{fill:${fill}`}</style>
      </defs>
      <path
        className="prefix__NewBulkEmail"
        d="M17.25 21a.75.75 0 01-.75-.75v-6a.75.75 0 011.5 0v6a.75.75 0 01-.75.75z"
      />
      <path
        className="prefix__NewBulkEmail"
        d="M20.25 18h-6a.75.75 0 010-1.5h6a.75.75 0 010 1.5zM8.25 16.5h-6A2.253 2.253 0 010 14.25v-12A2.252 2.252 0 012.25 0h18a2.253 2.253 0 012.25 2.25V9A.75.75 0 0121 9V2.25a.751.751 0 00-.75-.75h-18a.75.75 0 00-.75.75v12a.751.751 0 00.75.75h6a.75.75 0 010 1.5z"
      />
      <path
        className="prefix__NewBulkEmail"
        d="M11.25 9a4.047 4.047 0 01-2.474-.841L.632 1.895A.752.752 0 111.546.7L9.69 6.969a2.56 2.56 0 003.119 0L20.954.7a.75.75 0 11.914 1.19l-8.144 6.269A4.052 4.052 0 0111.25 9zM17.25 24A6.75 6.75 0 1124 17.25 6.758 6.758 0 0117.25 24zm0-12a5.25 5.25 0 105.25 5.25A5.256 5.256 0 0017.25 12z"
      />
    </svg>
  );
};

export const FeeAgreementTempIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = theme.palette.grey[600], ...rest } = props;

  return (
    <svg width={size} height={size} viewBox="0 0 30.025 30" {...rest}>
      <defs>
        <style>{`.prefix__cFeeAgreementIcon{fill:${fill}}`}</style>
      </defs>
      <path fill="none" d="M.025 0h30v30h-30z" />
      <path
        className="prefix__cFeeAgreementIcon"
        d="M3.685 27H2.25A2.253 2.253 0 010 24.75v-18A3.754 3.754 0 013.75 3h13.5a.75.75 0 010 1.5H3.75A2.252 2.252 0 001.5 6.75v18a.751.751 0 00.75.75h1.435a.75.75 0 010 1.5z"
      />
      <path
        className="prefix__cFeeAgreementIcon"
        d="M10.5 8.25H3.75a.75.75 0 010-1.5h6.75a.75.75 0 010 1.5zM10.5 11.25H3.75a.75.75 0 010-1.5h6.75a.75.75 0 010 1.5zM7.109 14.25H3.75a.75.75 0 010-1.5h3.359a.75.75 0 010 1.5zM15 13.5a.75.75 0 01-.75-.75V6a3 3 0 016 0v1.5a.75.75 0 01-.75.75h-3.75v4.5a.75.75 0 01-.75.75zm.75-6.75h3V6a1.5 1.5 0 10-3 0zM16.962 24.318a.75.75 0 01-.147-1.485l4.788-.958a.75.75 0 01.294 1.471l-4.787.954a.742.742 0 01-.148.018zM14.634 19.949a2.177 2.177 0 01-.883-.186 2.244 2.244 0 01-1.178-1.254 2.271 2.271 0 011.057-2.825l2.27-1.137a2.726 2.726 0 012.192-.125l4.651 1.832a.752.752 0 01-.551 1.4l-4.638-1.829a1.218 1.218 0 00-.975.063l-2.268 1.132a.77.77 0 00-.341.957.746.746 0 00.388.42.694.694 0 00.528.006l2.255-.954a.751.751 0 11.584 1.383l-2.26.954a2.187 2.187 0 01-.831.163z"
      />
      <path
        className="prefix__cFeeAgreementIcon"
        d="M13.47 26.964a1.57 1.57 0 01-1.125-.474l-2.8-2.134H8.2a.75.75 0 010-1.5h1.6a.749.749 0 01.455.153l3.045 2.326a.782.782 0 01.107.1.078.078 0 00.11.008l4.26-3.517a.092.092 0 00.023-.126l-2.312-2.566a.751.751 0 011.116-1l2.346 2.609a1.6 1.6 0 01-.208 2.244L14.477 26.6a1.574 1.574 0 01-1.007.364zM8.194 18.35a.75.75 0 01-.294-1.441l3.57-1.513a2.534 2.534 0 012.463.305l.274.222a.75.75 0 01-.943 1.166l-.247-.2a1.028 1.028 0 00-.976-.107L8.487 18.29a.742.742 0 01-.293.06z"
      />
      <path
        className="prefix__cFeeAgreementIcon"
        d="M7.112 25.108H6.75a.75.75 0 010-1.5h.3a.4.4 0 00.45-.368v-5.313a.381.381 0 00-.411-.322H6.75a.75.75 0 110-1.5h.3A1.887 1.887 0 019 17.882v5.4a1.906 1.906 0 01-1.888 1.826zM22.853 25.109A1.889 1.889 0 0121 23.329v-5.4a1.886 1.886 0 011.99-1.82h.26a.75.75 0 010 1.5h-.3a.411.411 0 00-.451.365v5.314a.38.38 0 00.409.322h.341a.75.75 0 010 1.5h-.3c-.031-.002-.064-.001-.096-.001z"
      />
    </svg>
  );
};

export const CancelCheckBox = (props: IconProps) => {
  const { size = defaultIconSize, fill = colors.red, ...rest } = props;

  return (
    <svg width={size} height={size} viewBox="0 0 18 18.008" {...rest}>
      <path
        d="M16 2v14H2V2zm0-2H2a2.006 2.006 0 00-2 2v14a2.006 2.006 0 002 2h14a2.006 2.006 0 002-2V2a2.006 2.006 0 00-2-2z"
        fill="#1a1c21"
      />
      <path
        d="M16 .008H2a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-14a2 2 0 00-2-2z"
        fill={fill}
      />
      <path
        d="M12.274 13.664a.85.85 0 01-.607-.252l-3.035-3.034-3.035 3.034a.86.86 0 11-1.214-1.216l3.035-3.034-3.034-3.033a.858.858 0 111.213-1.213L8.632 7.95l3.032-3.034a.858.858 0 111.213 1.213L9.843 9.164l3.038 3.032a.858.858 0 01-.608 1.465z"
        fill={colors.white}
      />
    </svg>
  );
};

export const InBoundCall = (props: IconProps) => {
  const { size = defaultIconSize, fill = theme.palette.grey[600] } = props;
  return (
    <svg width={size} height={size} viewBox="0 0 20 20.003" {...props}>
      <path
        fill={fill}
        d="M12.737 20.003a4.521 4.521 0 01-2.431-.714l-.023-.016A35.42 35.42 0 01.727 9.719a4.5 4.5 0 01.6-5.642l.542-.542a1.937 1.937 0 012.736 0l2.281 2.28a1.938 1.938 0 010 2.737.646.646 0 000 .912l3.65 3.649a.647.647 0 00.912 0 1.94 1.94 0 012.737 0l2.281 2.279a1.937 1.937 0 010 2.738l-.541.54a4.5 4.5 0 01-3.188 1.333zM3.237 4.26a.639.639 0 00-.455.188l-.543.542a3.205 3.205 0 00-.44 4.013 34.119 34.119 0 009.205 9.2l.009.006.009.006a3.2 3.2 0 003.99-.458l.541-.541a.644.644 0 000-.912l-2.28-2.28a.646.646 0 00-.912 0 1.941 1.941 0 01-2.737 0l-3.65-3.651a1.934 1.934 0 010-2.736.645.645 0 000-.912l-2.28-2.277a.643.643 0 00-.457-.188z"
      />
      <path
        fill={fill}
        d="M10.97 9.675a.645.645 0 01-.456-1.1L18.899.189a.645.645 0 11.912.912l-8.385 8.385a.64.64 0 01-.456.189z"
      />
      <path
        fill={fill}
        d="M16.13 9.675h-5.16a.645.645 0 01-.645-.645V3.87a.645.645 0 111.29 0v4.515h4.515a.645.645 0 010 1.29z"
      />
    </svg>
  );
};

export const MissedCall = (props: IconProps) => {
  const { size = defaultIconSize, fill = theme.palette.grey[600] } = props;

  return (
    <svg width={size} height={size} viewBox="0 0 20 20.003" {...props}>
      <defs>
        <style>{`.prefix__aMissedCall{fill:${fill}}`}</style>
      </defs>
      <path
        className="prefix__aMissedCall"
        d="M12.338 19.998a4.38 4.38 0 01-2.355-.691l-.022-.009A34.313 34.313 0 01.706 10.04a4.354 4.354 0 01.58-5.465l.525-.525a1.876 1.876 0 012.65 0l2.21 2.21a1.877 1.877 0 010 2.652.626.626 0 000 .883l3.535 3.535a.627.627 0 00.884 0 1.879 1.879 0 012.651 0l2.211 2.208a1.877 1.877 0 010 2.653l-.524.523a4.361 4.361 0 01-3.09 1.284zM3.136 4.752a.619.619 0 00-.441.182l-.526.525a3.1 3.1 0 00-.427 3.887 33.053 33.053 0 008.918 8.914l.008.006.008.006a3.1 3.1 0 003.866-.443l.524-.524a.624.624 0 000-.883l-2.21-2.209a.624.624 0 00-.442-.184.619.619 0 00-.442.183 1.879 1.879 0 01-2.651 0l-3.533-3.534a1.874 1.874 0 010-2.65.625.625 0 000-.884l-2.21-2.21a.623.623 0 00-.442-.182zM15.002 10a5 5 0 115-5 5 5 0 01-5 5zm0-8.75A3.749 3.749 0 1018.75 5a3.754 3.754 0 00-3.748-3.75z"
      />
      <path
        className="prefix__aMissedCall"
        d="M13.676 6.949a.625.625 0 01-.442-1.066l2.651-2.651a.624.624 0 11.883.883l-2.651 2.65a.619.619 0 01-.441.184z"
      />
      <path
        className="prefix__aMissedCall"
        d="M16.327 6.949a.618.618 0 01-.442-.183l-2.651-2.652a.624.624 0 01.883-.883l2.651 2.651a.625.625 0 01-.442 1.066z"
      />
    </svg>
  );
};

export const OutBoundCall = (props: IconProps) => {
  const { size = defaultIconSize, fill = theme.palette.grey[600] } = props;

  return (
    <svg width={size} height={size} viewBox="0 0 20 20.003" {...props}>
      <path
        fill={fill}
        d="M12.338 19.998a4.38 4.38 0 01-2.355-.691l-.022-.009A34.313 34.313 0 01.706 10.04a4.354 4.354 0 01.58-5.465l.525-.525a1.876 1.876 0 012.65 0l2.21 2.21a1.877 1.877 0 010 2.652.626.626 0 000 .883l3.535 3.535a.627.627 0 00.884 0 1.879 1.879 0 012.651 0l2.211 2.208a1.877 1.877 0 010 2.653l-.524.523a4.361 4.361 0 01-3.09 1.284zM3.136 4.752a.619.619 0 00-.441.182l-.526.525a3.1 3.1 0 00-.427 3.887 33.053 33.053 0 008.918 8.914l.008.006.008.006a3.1 3.1 0 003.866-.443l.524-.524a.624.624 0 000-.883l-2.21-2.209a.624.624 0 00-.442-.184.619.619 0 00-.442.183 1.879 1.879 0 01-2.651 0l-3.533-3.534a1.874 1.874 0 010-2.65.625.625 0 000-.884l-2.21-2.21a.623.623 0 00-.442-.182zM11.252 9.373a.625.625 0 01-.442-1.066L18.933.183a.624.624 0 01.883.883l-8.123 8.123a.62.62 0 01-.441.184z"
      />
      <path
        fill={fill}
        d="M19.375 6.248a.625.625 0 01-.625-.625V1.25h-4.374a.625.625 0 110-1.25h5a.625.625 0 01.625.625v5a.625.625 0 01-.626.623z"
      />
    </svg>
  );
};

export const Operating10Icon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      {...rest}
    >
      <g transform="translate(0 0.001)">
        <path
          fill={fill}
          d="M6,24a.68.68,0,0,1-.09-.006.745.745,0,0,1-.621-.507L3.926,19.4.6,18.734a.749.749,0,0,1-.434-1.209l4.058-4.959a.75.75,0,0,1,1.161.95L2.121,17.509l2.526.5a.75.75,0,0,1,.564.5l1,3,3.1-4.917a.749.749,0,1,1,1.268.8L6.634,23.649A.751.751,0,0,1,6,24Z"
        />
        <path
          fill={fill}
          d="M18,24a.754.754,0,0,1-.635-.349l-3.944-6.258a.75.75,0,0,1,1.269-.8l3.1,4.918,1-3a.753.753,0,0,1,.565-.5l2.527-.506-3.267-3.992a.75.75,0,0,1,1.16-.95l4.057,4.959a.749.749,0,0,1-.433,1.209l-3.323.666-1.362,4.086a.749.749,0,0,1-.622.507A.692.692,0,0,1,18,24Z"
        />
        <path
          fill={fill}
          d="M12,18a9,9,0,1,1,9-9A9.01,9.01,0,0,1,12,18ZM12,1.5A7.5,7.5,0,1,0,19.5,9,7.508,7.508,0,0,0,12,1.5Z"
        />
        <path
          fill={fill}
          d="M15,12a2.253,2.253,0,0,1-2.25-2.25v-1.5a2.25,2.25,0,0,1,4.5,0v1.5A2.253,2.253,0,0,1,15,12Zm0-4.5a.752.752,0,0,0-.75.75v1.5a.75.75,0,0,0,1.5,0v-1.5A.752.752,0,0,0,15,7.5Z"
        />
        <path
          fill={fill}
          d="M9.75,12a.75.75,0,0,1-.75-.75V7.5H8.25a.75.75,0,0,1,0-1.5H9a1.5,1.5,0,0,1,1.5,1.5v3.75A.75.75,0,0,1,9.75,12Z"
        />
        <path fill={fill} d="M11.25,12h-3a.75.75,0,0,1,0-1.5h3a.75.75,0,0,1,0,1.5Z" />
      </g>
    </svg>
  );
};

export const FullScreenIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = defaultIconColor } = props;

  return (
    <svg width={size} height={size} viewBox="0 0 20.426 21.471" {...props}>
      <path
        fill={fill}
        d="M20.368.463A.755.755 0 0019.676 0h-4.244a.75.75 0 000 1.5h2.433L7.754 11.61a.75.75 0 101.061 1.061l10.111-10.11v2.432a.75.75 0 001.5 0V.75a.751.751 0 00-.058-.287z"
      />
      <path
        fill={fill}
        d="M17.251 8.494a.75.75 0 00-.75.75v9.977a.752.752 0 01-.75.75H2.25a.752.752 0 01-.75-.75v-13.5a.751.751 0 01.75-.75h8.071a.75.75 0 000-1.5H2.25A2.253 2.253 0 000 5.721v13.5a2.253 2.253 0 002.25 2.25h13.5a2.253 2.253 0 002.25-2.25V9.244a.75.75 0 00-.749-.75z"
      />
    </svg>
  );
};

export const PopperArrow = (props: IconProps) => {
  const { size = defaultIconSize, fill = defaultIconColor } = props;

  return (
    <svg width={size} height={size} viewBox="0 0 90 44.998" {...props}>
      <path fill={fill} d="M90 0H0l44.999 44.998z" />
    </svg>
  );
};

export const ForwardIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = defaultIconColor } = props;
  return (
    <svg width={size} height={size} viewBox="0 0 20.451 19.41" {...props}>
      <path
        fill={fill}
        d="M.75 19.405a.75.75 0 01-.75-.75v-6a8.259 8.259 0 018.25-8.249h2.249V2.248A2.248 2.248 0 0112.748.005a2.253 2.253 0 011.648.72l5.464 5.91a2.265 2.265 0 010 3.051l-5.459 5.919a2.25 2.25 0 01-3.9-1.527v-2.173H8.25a6.758 6.758 0 00-6.75 6.75.75.75 0 01-.75.75zm7.5-9h3a.75.75 0 01.75.75v2.913a.749.749 0 00.24.549.664.664 0 00.538.2.743.743 0 00.522-.239l5.458-5.913a.755.755 0 000-1.017l-5.46-5.914a.75.75 0 00-.548-.238.745.745 0 00-.53.218.753.753 0 00-.22.531v2.911a.749.749 0 01-.75.751h-3a6.757 6.757 0 00-6.75 6.749v1.262a8.245 8.245 0 016.75-3.513z"
      />
    </svg>
  );
};

export const SignaturesIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = defaultIconColor, ...rest } = props;
  return (
    <svg width={size} height={size} viewBox="0 0 23.97 23.954" {...rest}>
      <path
        fill={fill}
        d="M1.022 10.178a.727.727 0 01-.172-.02.749.749 0 01-.558-.9A12.133 12.133 0 011.45 6.222a.75.75 0 011.317.717 10.674 10.674 0 00-1.015 2.664.751.751 0 01-.73.575zM4.15 4.671a.75.75 0 01-.518-1.293 12.926 12.926 0 012.607-1.922.75.75 0 01.731 1.309 11.411 11.411 0 00-2.3 1.7.748.748 0 01-.52.206zM10.971 23.954h-.067a11.841 11.841 0 01-3.171-.727.75.75 0 11.533-1.4 10.383 10.383 0 002.77.636.75.75 0 01-.065 1.5zM5.075 21.637a.75.75 0 01-.456-.155 11.569 11.569 0 01-2.279-2.33.75.75 0 011.209-.887 10.056 10.056 0 001.984 2.027.75.75 0 01-.458 1.345zM1.363 16.503a.751.751 0 01-.705-.5 11.256 11.256 0 01-.654-3.193.751.751 0 011.5-.086 9.774 9.774 0 00.57 2.771.749.749 0 01-.7 1.006zM14.213 23.779a.75.75 0 01-.149-1.485 10.5 10.5 0 003.691-19.051 10.441 10.441 0 00-7.892-1.528.75.75 0 01-.3-1.47 12 12 0 0112.414 18.378 11.93 11.93 0 01-7.613 5.142.772.772 0 01-.151.014z"
      />
      <path
        fill={fill}
        d="M6.322 18.835a.592.592 0 01-.582-.7c.1-.539.668-3.267 1.449-4.053a2.383 2.383 0 011.6-.73l-.014-.024a.591.591 0 010-.837l6.146-6.146-.4-.4a.568.568 0 00-.8 0l-2.878 2.871a.592.592 0 11-.837-.837l2.872-2.872a1.753 1.753 0 012.478 0l.459.459a2.33 2.33 0 012.825 3.659l-6.565 6.565a.591.591 0 01-.837 0l-.02-.02a2.418 2.418 0 01-.732 1.61c-.777.779-3.511 1.339-4.05 1.444a.615.615 0 01-.114.011zm2.593-4.305a1.214 1.214 0 00-.878.376 7.664 7.664 0 00-.938 2.56 7.587 7.587 0 002.555-.929 1.221 1.221 0 00.073-1.7 1.222 1.222 0 00-.813-.307zm2.741 0l3.266-3.266-1.626-1.619-3.266 3.265zm4.1-4.1l2.043-2.043a1.157 1.157 0 000-1.626 1.156 1.156 0 00-1.624 0l-2.041 2.046z"
      />
    </svg>
  );
};

export const CollaborationsIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" {...rest}>
      <defs>
        <style>{`.collab{fill:${fill};}`}</style>
      </defs>
      <path
        className="collab"
        d="M16.125,21.75a.632.632,0,0,1-.138-.015A6.971,6.971,0,0,1,10.5,14.874v-2.5A1.877,1.877,0,0,1,12.375,10.5h7.5a1.877,1.877,0,0,1,1.875,1.875v2.5a7.059,7.059,0,0,1-5.489,6.861A.606.606,0,0,1,16.125,21.75Zm-3.75-10a.625.625,0,0,0-.625.625v2.5a5.739,5.739,0,0,0,4.375,5.607A5.814,5.814,0,0,0,20.5,14.876v-2.5a.625.625,0,0,0-.625-.625Z"
        transform="translate(-1.75 -1.75)"
      />
      <path
        className="collab"
        d="M16.75,19.25a.625.625,0,0,1-.625-.625v-1.25h-1.25a.625.625,0,1,1,0-1.25h1.25v-1.25a.625.625,0,1,1,1.25,0v1.25h1.25a.625.625,0,1,1,0,1.25h-1.25v1.25A.625.625,0,0,1,16.75,19.25Z"
        transform="translate(-2.375 -2.375)"
      />
      <path
        className="collab"
        d="M5.375,6.25A3.125,3.125,0,1,1,8.5,3.125,3.128,3.128,0,0,1,5.375,6.25Zm0-5A1.875,1.875,0,1,0,7.25,3.125,1.877,1.877,0,0,0,5.375,1.25Z"
        transform="translate(-0.375)"
      />
      <path
        className="collab"
        d="M3.125,21.25a.622.622,0,0,1-.622-.562L1.934,15H.625A.625.625,0,0,1,0,14.375V12.5A5.028,5.028,0,0,1,1.016,9.479a4.97,4.97,0,0,1,3.3-1.932A5.041,5.041,0,0,1,5.009,7.5,4.952,4.952,0,0,1,8.022,8.516a.625.625,0,0,1-.378,1.123h0a.624.624,0,0,1-.377-.127,3.71,3.71,0,0,0-2.257-.763A3.752,3.752,0,0,0,1.25,12.5v1.25H2.5a.622.622,0,0,1,.622.563L3.691,20H6.309l.319-3.217a.624.624,0,0,1,.624-.563l.057,0a.626.626,0,0,1,.562.684L7.5,20.686a.623.623,0,0,1-.622.563Z"
        transform="translate(0 -1.25)"
      />
      <path
        className="collab"
        d="M15.937,5.625A2.812,2.812,0,1,1,18.75,2.812,2.816,2.816,0,0,1,15.937,5.625Zm0-4.375A1.562,1.562,0,1,0,17.5,2.812,1.564,1.564,0,0,0,15.937,1.25Z"
        transform="translate(-2.188)"
      />
      <path
        className="collab"
        d="M19.061,9.125a.626.626,0,0,1-.541-.312,3.1,3.1,0,0,0-1.9-1.456,3.128,3.128,0,0,0-3.161.962.625.625,0,0,1-.471.213h0A.625.625,0,0,1,12.519,7.5,4.384,4.384,0,0,1,15.807,6a4.433,4.433,0,0,1,1.137.15A4.345,4.345,0,0,1,19.6,8.185a.626.626,0,0,1-.228.854A.61.61,0,0,1,19.061,9.125Z"
        transform="translate(-2.061 -1)"
      />
    </svg>
  );
};

export const OpenMailIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = colors.black } = props;

  return (
    <svg width={size} height={size} viewBox="0 0 39.65 39.655" {...props}>
      <defs>
        <clipPath id="OpenMailIcon">
          <path className="OpenMailIcon" d="M0 0h39.65v39.655H0z" />
        </clipPath>
        <style>{`.OpenMailIcon{fill:${fill}}`}</style>
      </defs>
      <g clipPath="url(#OpenMailIcon)">
        <path
          className="OpenMailIcon"
          d="M3.965 39.657A3.969 3.969 0 010 35.692V15.867a.573.573 0 01.005-.078 1.242 1.242 0 01.046-.28l.026-.079a1.208 1.208 0 01.1-.226 1.21 1.21 0 01.048-.076 1.331 1.331 0 01.175-.205c.019-.019.042-.042.063-.06L15.04 2.051c.088-.1.18-.183.273-.273A6.6 6.6 0 0119.827.001h.222a6.558 6.558 0 014.557 2.05L39.2 14.875a.787.787 0 01.067.067 1.081 1.081 0 01.159.194c.009.016.041.067.051.081a1.25 1.25 0 01.106.245.31.31 0 01.021.069 1.058 1.058 0 01.041.268.3.3 0 01.007.069v19.824a3.969 3.969 0 01-3.965 3.965zm-1.322-3.965a1.323 1.323 0 001.322 1.322h31.72a1.322 1.322 0 001.322-1.322V18.601l-8.487 6.733 4.136 4.134a1.321 1.321 0 010 1.87 1.319 1.319 0 01-1.87 0l-4.351-4.353-2.522 2a6.6 6.6 0 01-8.17 0l-2.527-2.007-4.352 4.361A1.321 1.321 0 117 29.47l4.136-4.134-8.493-6.735zM17.38 26.92a3.956 3.956 0 004.892-.005l13.992-11.1L22.815 4.001c-.032-.028-.062-.06-.092-.09a3.942 3.942 0 00-2.765-1.258h-.137a3.95 3.95 0 00-2.7 1.066c-.065.062-.13.123-.192.19-.028.032-.06.062-.09.09L3.383 15.814z"
        />
      </g>
    </svg>
  );
};

export const FeeAgreementPositiveIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 21 25" {...rest}>
      <defs>
        <style>{`.fa{fill:${fill};}`}</style>
      </defs>
      <g transform="translate(9.025 -18.364)">
        <g transform="translate(-10 32)">
          <path
            className="fa"
            d="M15.52,5.782a.75.75,0,0,0-1.061,1.061l2.25,2.25a.75.75,0,0,0,.53.22h.029a.752.752,0,0,0,.541-.261l4.5-5.25a.75.75,0,1,0-1.139-.977L17.2,7.46Z"
            transform="translate(-0.502 -0.312)"
          />
          <path
            className="fa"
            d="M16.4,12.244a5.906,5.906,0,0,0,.855.062,6.007,6.007,0,0,0,5.932-5.145A.75.75,0,1,0,21.7,6.948a4.494,4.494,0,1,1-2.735-4.795A.75.75,0,1,0,19.536.768,6,6,0,1,0,16.4,12.244Z"
            transform="translate(-0.502 -0.312)"
          />
        </g>
        <g transform="translate(-9.025 18.364)">
          <path
            className="fa"
            d="M3.685,24H2.25A2.253,2.253,0,0,1,0,21.75v-18A3.754,3.754,0,0,1,3.75,0h13.5a.75.75,0,0,1,0,1.5H3.75A2.252,2.252,0,0,0,1.5,3.75v18a.751.751,0,0,0,.75.75H3.685a.75.75,0,0,1,0,1.5Z"
          />
          <path className="fa" d="M10.5,5.25H3.75a.75.75,0,0,1,0-1.5H10.5a.75.75,0,0,1,0,1.5Z" />
          <path className="fa" d="M10.5,8.25H3.75a.75.75,0,0,1,0-1.5H10.5a.75.75,0,0,1,0,1.5Z" />
          <path className="fa" d="M7.109,11.25H3.75a.75.75,0,0,1,0-1.5H7.109a.75.75,0,0,1,0,1.5Z" />
          <path
            className="fa"
            d="M15,10.5a.75.75,0,0,1-.75-.75V3a3,3,0,0,1,6,0V4.5a.75.75,0,0,1-.75.75H15.75v4.5A.75.75,0,0,1,15,10.5Zm.75-6.75h3V3a1.5,1.5,0,1,0-3,0Z"
          />
        </g>
      </g>
    </svg>
  );
};

export const FeeAgreementNegativeIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 21 25" {...rest}>
      <defs>
        <style>{`.fa{fill:${fill};}`}</style>
      </defs>
      <g transform="translate(-1510.975 -132)">
        <g transform="translate(1510.975 132)">
          <path
            className="fa"
            d="M3.685,24H2.25A2.253,2.253,0,0,1,0,21.75v-18A3.754,3.754,0,0,1,3.75,0h13.5a.75.75,0,0,1,0,1.5H3.75A2.252,2.252,0,0,0,1.5,3.75v18a.751.751,0,0,0,.75.75H3.685a.75.75,0,0,1,0,1.5Z"
          />
          <path className="fa" d="M10.5,5.25H3.75a.75.75,0,0,1,0-1.5H10.5a.75.75,0,0,1,0,1.5Z" />
          <path className="fa" d="M10.5,8.25H3.75a.75.75,0,0,1,0-1.5H10.5a.75.75,0,0,1,0,1.5Z" />
          <path className="fa" d="M7.109,11.25H3.75a.75.75,0,0,1,0-1.5H7.109a.75.75,0,0,1,0,1.5Z" />
          <path
            className="fa"
            d="M15,10.5a.75.75,0,0,1-.75-.75V3a3,3,0,0,1,6,0V4.5a.75.75,0,0,1-.75.75H15.75v4.5A.75.75,0,0,1,15,10.5Zm.75-6.75h3V3a1.5,1.5,0,1,0-3,0Z"
          />
        </g>
        <g transform="matrix(0.719, -0.695, 0.695, 0.719, 1517.883, 150.354)">
          <path
            className="fa"
            d="M16.4,22.306a5.9,5.9,0,1,1,5.9-5.9A5.909,5.909,0,0,1,16.4,22.306Zm0-10.494A4.591,4.591,0,1,0,20.994,16.4,4.6,4.6,0,0,0,16.4,11.812Z"
            transform="translate(-10.5 -10.5)"
          />
          <path
            className="fa"
            d="M17.156,20.059A.656.656,0,0,1,16.5,19.4V14.156a.656.656,0,0,1,1.312,0V19.4A.656.656,0,0,1,17.156,20.059Z"
            transform="translate(-11.253 -10.877)"
          />
          <path
            className="fa"
            d="M19.4,17.812H14.156a.656.656,0,0,1,0-1.312H19.4a.656.656,0,0,1,0,1.312Z"
            transform="translate(-10.877 -11.253)"
          />
        </g>
      </g>
    </svg>
  );
};

export const SendoutsIcon = ({
  fill = theme.palette.grey[600],
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} {...rest} viewBox="0 0 24 24">
      <defs>
        <style>{`.fa{fill:${fill};}`}</style>
      </defs>
      <path
        fill={fill}
        d="M5.25,18A3.75,3.75,0,1,1,9,14.25,3.754,3.754,0,0,1,5.25,18Zm0-6A2.25,2.25,0,1,0,7.5,14.25,2.252,2.252,0,0,0,5.25,12Z"
      />
      <path
        fill={fill}
        d="M9.75,24A.75.75,0,0,1,9,23.25a3.75,3.75,0,0,0-7.5,0,.75.75,0,0,1-1.5,0,5.25,5.25,0,0,1,10.5,0A.75.75,0,0,1,9.75,24Z"
      />
      <path
        fill={fill}
        d="M18.755,18A3.75,3.75,0,0,1,15,14.25a.75.75,0,1,1,1.5,0,2.25,2.25,0,1,0,4.2-1.125.75.75,0,1,1,1.3-.748A3.752,3.752,0,0,1,18.755,18Z"
      />
      <path
        fill={fill}
        d="M23.25,24a.75.75,0,0,1-.75-.75,3.75,3.75,0,0,0-7.5,0,.75.75,0,0,1-1.5,0,5.25,5.25,0,0,1,10.5,0A.75.75,0,0,1,23.25,24Z"
      />
      <path
        fill={fill}
        d="M11.25,15a.75.75,0,0,1-.75-.75V10.5H8.25a.75.75,0,0,1-.75-.75v-9A.75.75,0,0,1,8.25,0h12A.75.75,0,0,1,21,.75v9a.75.75,0,0,1-.75.75H16.061l-4.28,4.28A.747.747,0,0,1,11.25,15Zm0-6a.75.75,0,0,1,.75.75v2.689l3.22-3.22A.754.754,0,0,1,15.75,9H19.5V1.5H9V9Z"
      />
      <path fill={fill} d="M11.25,4.5a.75.75,0,0,1,0-1.5h6a.75.75,0,0,1,0,1.5Z" />
      <path fill={fill} d="M11.25,7.5a.75.75,0,0,1,0-1.5h6a.75.75,0,0,1,0,1.5Z" />
    </svg>
  );
};

export const ProfileIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = colors.black } = props;

  return (
    <svg width={size} height={size} viewBox="0 0 21 24" {...props}>
      <path
        fill={fill}
        d="M2.25 24A2.252 2.252 0 010 21.75V2.25A2.252 2.252 0 012.25 0h16.5A2.252 2.252 0 0121 2.25v19.5A2.252 2.252 0 0118.75 24zm0-22.5a.75.75 0 00-.75.75v19.5a.75.75 0 00.75.75h16.5a.75.75 0 00.75-.75V2.25a.75.75 0 00-.75-.75z"
      />
      <path
        fill={fill}
        d="M10.5 13.943a4.86 4.86 0 114.86-4.86 4.865 4.865 0 01-4.86 4.86zm0-8.22a3.36 3.36 0 103.36 3.36 3.363 3.363 0 00-3.36-3.36z"
      />
      <path
        fill={fill}
        d="M3.75 19.777a.76.76 0 01-.349-.086.751.751 0 01-.314-1.013 8.38 8.38 0 0114.827 0 .749.749 0 01-.663 1.1.748.748 0 01-.664-.4 6.88 6.88 0 00-12.173 0 .75.75 0 01-.664.399z"
      />
    </svg>
  );
};

export const GlipIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = colors.black } = props;

  return (
    <svg width={size} height={size} viewBox="0 0 23.421 23.421" {...props}>
      <path
        d="M5.123 23.421a.732.732 0 01-.732-.732v-3.66H2.2a2.2 2.2 0 01-2.2-2.2V2.2A2.2 2.2 0 012.2 0h19.025a2.2 2.2 0 012.2 2.2v14.634a2.2 2.2 0 01-2.2 2.2h-10l-5.66 4.245a.727.727 0 01-.442.142zM2.2 1.464a.732.732 0 00-.732.732v14.638a.733.733 0 00.732.732h2.923a.732.732 0 01.732.732v2.928l4.684-3.512a.73.73 0 01.439-.147h10.247a.733.733 0 00.732-.732V2.2a.733.733 0 00-.732-.732z"
        fill={fill}
      />
    </svg>
  );
};

export const ListView = ({
  size = defaultIconSize,
  fill = theme.palette.grey[600],
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...rest}
    >
      <path
        d="M4 .747H1.5a1.5 1.5 0 00-1.5 1.5v2.5a1.5 1.5 0 001.5 1.5H4a1.5 1.5 0 001.5-1.5v-2.5A1.5 1.5 0 004 .747zM4 9.247H1.5a1.5 1.5 0 00-1.5 1.5v2.5a1.5 1.5 0 001.5 1.5H4a1.5 1.5 0 001.5-1.5v-2.5a1.5 1.5 0 00-1.5-1.5zM4 17.747H1.5a1.5 1.5 0 00-1.5 1.5v2.5a1.5 1.5 0 001.5 1.5H4a1.5 1.5 0 001.5-1.5v-2.5a1.5 1.5 0 00-1.5-1.5zM22.5.747H10a1.5 1.5 0 00-1.5 1.5v2.5a1.5 1.5 0 001.5 1.5h12.5a1.5 1.5 0 001.5-1.5v-2.5a1.5 1.5 0 00-1.5-1.5zM22.5 9.247H10a1.5 1.5 0 00-1.5 1.5v2.5a1.5 1.5 0 001.5 1.5h12.5a1.5 1.5 0 001.5-1.5v-2.5a1.5 1.5 0 00-1.5-1.5zM22.5 17.747H10a1.5 1.5 0 00-1.5 1.5v2.5a1.5 1.5 0 001.5 1.5h12.5a1.5 1.5 0 001.5-1.5v-2.5a1.5 1.5 0 00-1.5-1.5z"
        fill={fill}
      />
    </svg>
  );
};

export const PhoneIcon = ({
  size = defaultIconSize,
  fill = theme.palette.grey[600],
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...rest}
    >
      <path
        d="M22.673 17.009l-2.452-2.453a2.81 2.81 0 00-3.979 0l-.5.5A54.367 54.367 0 018.94 8.245l.5-.5a2.817 2.817 0 000-3.978l-2.457-2.45a2.883 2.883 0 00-3.983 0L1.66 2.663a3.981 3.981 0 00-.5 4.994 54.173 54.173 0 0015.173 15.176 4.015 4.015 0 005-.5l1.345-1.346a2.81 2.81 0 000-3.977l-.005-.001z"
        fill={fill}
      />
    </svg>
  );
};

export const MatchIcon = ({
  fill = defaultIconColor,
  size = defaultIconSize,
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 19.51 21"
      {...rest}
    >
      <defs>
        <clipPath id="prefix__a">
          <path className="prefix__a" d="M0 0h19.51v21H0z" />
        </clipPath>
        <style>{`.prefix__a{fill:${fill}}`}</style>
      </defs>
      <g clipPath="url(#prefix__a)">
        <path
          className="prefix__a"
          d="M17.76 21H6.253A1.752 1.752 0 014.5 19.25V4.75A1.752 1.752 0 016.253 3H17.76a1.752 1.752 0 011.75 1.75v14.5A1.752 1.752 0 0117.76 21M6.253 4.5A.25.25 0 006 4.75v14.5a.25.25 0 00.25.25h11.51a.25.25 0 00.25-.25V4.75a.25.25 0 00-.25-.25z"
        />
        <path
          className="prefix__a"
          d="M5.252 18h-3A2.252 2.252 0 010 15.75V2.25A2.252 2.252 0 012.251 0h10.5a2.252 2.252 0 012.251 2.25v1.5a.75.75 0 11-1.5 0v-1.5a.751.751 0 00-.751-.75h-10.5a.75.75 0 00-.751.75v13.5a.75.75 0 00.751.75h3a.75.75 0 010 1.5"
        />
        <path
          className="prefix__a"
          d="M15.758 9h-3a.75.75 0 010-1.5h3a.75.75 0 010 1.5M9.005 9a.744.744 0 01-.53-.22l-.751-.75a.75.75 0 011.061-1.06l.22.219.97-.969a.75.75 0 011.061 1.06l-1.5 1.5a.744.744 0 01-.53.22M15.758 13.5h-3a.75.75 0 010-1.5h3a.75.75 0 010 1.5M9.005 13.5a.744.744 0 01-.53-.22l-.751-.75a.75.75 0 011.061-1.06l.22.219.97-.969a.75.75 0 011.061 1.06l-1.5 1.5a.744.744 0 01-.53.22M15.758 18h-3a.75.75 0 010-1.5h3a.75.75 0 010 1.5M9.005 18a.744.744 0 01-.53-.22l-.751-.75a.75.75 0 011.061-1.06l.22.219.97-.969a.75.75 0 011.061 1.06l-1.5 1.5a.744.744 0 01-.53.22"
        />
      </g>
    </svg>
  );
};

export const PlacementsIcon = ({
  size = defaultIconSize,
  fill = theme.palette.grey[600],
  ...rest
}: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <path
        fill={fill}
        d="M.75 23.99a.75.75 0 01-.75-.75v-9a.75.75 0 011.5 0v9a.75.75 0 01-.75.75z"
      />
      <path
        fill={fill}
        d="M15.75 22.49h-15a.75.75 0 010-1.5h14.121a2.253 2.253 0 00-2.121-1.5H9.001a.75.75 0 01-.75-.75 2.253 2.253 0 00-2.25-2.25H.75a.75.75 0 010-1.5h5.251a3.755 3.755 0 013.674 3h3.075a3.755 3.755 0 013.75 3.75.75.75 0 01-.75.75z"
      />
      <path
        fill={fill}
        d="M9.001 19.49h-3a.75.75 0 010-1.5h3a.75.75 0 010 1.5zM23.25 18.001h-6.749a.75.75 0 010-1.5h5.951a6.045 6.045 0 00-2.847-4.384 6 6 0 00-8.241 2.028.75.75 0 01-1.283-.777 7.5 7.5 0 0110.3-2.534 7.547 7.547 0 013.618 6.417.751.751 0 01-.75.75zM17.897 5.618a7.639 7.639 0 01-5.492-2.317.75.75 0 111.079-1.042 6.138 6.138 0 006.808 1.368.75.75 0 01.592 1.378 7.553 7.553 0 01-2.987.613z"
      />
      <path
        fill={fill}
        d="M16.501 9.75a4.875 4.875 0 114.875-4.875 4.881 4.881 0 01-4.875 4.875zm0-8.25a3.375 3.375 0 103.375 3.375A3.379 3.379 0 0016.501 1.5z"
      />
      <path
        fill={fill}
        d="M16.501 14.25a.75.75 0 01-.75-.75v-3a.75.75 0 011.5 0v3a.75.75 0 01-.75.75z"
      />
    </svg>
  );
};

export const AvgHandleTimeCallIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = theme.palette.grey[600] } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 55.108 55.119">
      <defs>
        <style>.a{fill}</style>
      </defs>
      <path
        fill={fill}
        className="a"
        d="M321.606,338.087a12.077,12.077,0,0,1-6.492-1.905l-.062-.044a94.41,94.41,0,0,1-25.507-25.5,12,12,0,0,1,1.6-15.059l1.446-1.446a5.172,5.172,0,0,1,7.3,0l6.088,6.086a5.163,5.163,0,0,1,0,7.307,1.724,1.724,0,0,0,0,2.433l9.738,9.74a1.722,1.722,0,0,0,2.436,0,5.175,5.175,0,0,1,7.307,0l6.09,6.086a5.171,5.171,0,0,1,0,7.307l-1.446,1.444A12,12,0,0,1,321.606,338.087Zm-25.358-42.024a1.714,1.714,0,0,0-1.219.505l-1.446,1.444a8.556,8.556,0,0,0-1.173,10.711,90.97,90.97,0,0,0,24.57,24.564l.025.016.021.016a8.544,8.544,0,0,0,10.652-1.219l1.444-1.444a1.722,1.722,0,0,0,0-2.436l-6.09-6.086a1.719,1.719,0,0,0-2.433,0,5.177,5.177,0,0,1-7.307,0l-9.738-9.743a5.163,5.163,0,0,1,0-7.3,1.722,1.722,0,0,0,0-2.436l-6.088-6.088A1.716,1.716,0,0,0,296.249,296.063Z"
        transform="translate(-287.606 -282.969)"
      />
      <path
        fill={fill}
        className="a"
        d="M313.386,315.965h0a13.774,13.774,0,1,1,13.774-13.774A13.792,13.792,0,0,1,313.386,315.965Zm0-24.1a10.33,10.33,0,1,0,10.33,10.33A10.343,10.343,0,0,0,313.386,291.86Z"
        transform="translate(-272.051 -288.417)"
      />
      <path
        fill={fill}
        className="a"
        d="M311.749,300.026h-5.165a1.721,1.721,0,0,1-1.722-1.722v-5.165a1.722,1.722,0,1,1,3.443,0v3.444h3.443a1.722,1.722,0,1,1,0,3.443Z"
        transform="translate(-265.249 -284.53)"
      />
    </svg>
  );
};
export const SentSMSIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = theme.palette.grey[600] } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 55.108 55.119">
      <defs>
        <style>.a{fill}</style>
      </defs>
      <g transform="translate(-287.612 -288.418)">
        <g transform="translate(287.612 288.418)">
          <path
            fill={fill}
            className="a"
            d="M296.207,339.55a1.719,1.719,0,0,1-1.719-1.719v-8.595h-1.719a5.163,5.163,0,0,1-5.157-5.157v-27.5a5.162,5.162,0,0,1,5.157-5.157h18.909a1.719,1.719,0,0,1,0,3.438H292.769a1.72,1.72,0,0,0-1.719,1.719v27.5a1.721,1.721,0,0,0,1.719,1.719h3.438a1.72,1.72,0,0,1,1.719,1.719v6.163l7.38-7.378a1.711,1.711,0,0,1,1.215-.5h24.066a1.723,1.723,0,0,0,1.719-1.719V313.765a1.719,1.719,0,0,1,3.438,0v10.314a5.163,5.163,0,0,1-5.157,5.157H307.232l-9.81,9.81A1.71,1.71,0,0,1,296.207,339.55Z"
            transform="translate(-287.612 -284.543)"
          />
          <path
            fill={fill}
            className="a"
            d="M308.831,305.608a1.719,1.719,0,0,1-1.215-2.934l5.661-5.661-5.661-5.661a1.719,1.719,0,0,1,2.432-2.43l6.876,6.876a1.717,1.717,0,0,1,0,2.43l-6.876,6.876A1.711,1.711,0,0,1,308.831,305.608Z"
            transform="translate(-262.418 -288.418)"
          />
          <path
            fill={fill}
            className="a"
            d="M301.33,308.608a1.72,1.72,0,0,1-1.719-1.719,15.488,15.488,0,0,1,15.471-15.471H325.4a1.719,1.719,0,1,1,0,3.438H315.082a12.048,12.048,0,0,0-12.035,12.033A1.718,1.718,0,0,1,301.33,308.608Z"
            transform="translate(-272.109 -284.543)"
          />
        </g>
      </g>
    </svg>
  );
};
export const ReceivedSMSIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = theme.palette.grey[600] } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 55.108 55.119">
      <defs>
        <style>.a{fill}</style>
      </defs>
      <g transform="translate(-287.612 -290.418)">
        <g transform="translate(287.612 290.418)">
          <path
            fill={fill}
            className="a"
            d="M295.862,337.616a1.649,1.649,0,0,1-1.65-1.65v-8.25h-1.65a4.956,4.956,0,0,1-4.95-4.95v-26.4a4.954,4.954,0,0,1,4.95-4.95h18.149a1.65,1.65,0,0,1,0,3.3H292.562a1.65,1.65,0,0,0-1.65,1.65v26.4a1.652,1.652,0,0,0,1.65,1.65h3.3a1.651,1.651,0,0,1,1.65,1.65v5.915L304.6,324.9a1.643,1.643,0,0,1,1.166-.484h23.1a1.653,1.653,0,0,0,1.65-1.65v-9.9a1.65,1.65,0,1,1,3.3,0v9.9a4.956,4.956,0,0,1-4.95,4.95H306.443l-9.415,9.415A1.642,1.642,0,0,1,295.862,337.616Z"
            transform="translate(-287.612 -289.219)"
          />
          <path
            fill={fill}
            className="a"
            d="M308.86,306.917a1.65,1.65,0,0,0,1.168-2.816l-5.434-5.434,5.434-5.434a1.65,1.65,0,0,0-2.334-2.332l-6.6,6.6a1.648,1.648,0,0,0,0,2.332l6.6,6.6A1.64,1.64,0,0,0,308.86,306.917Z"
            transform="translate(-272.014 -290.418)"
          />
          <path
            fill={fill}
            className="a"
            d="M325.363,309.917a1.65,1.65,0,0,0,1.65-1.65,14.866,14.866,0,0,0-14.851-14.849h-9.9a1.65,1.65,0,1,0,0,3.3h9.9a11.563,11.563,0,0,1,11.552,11.549A1.65,1.65,0,0,0,325.363,309.917Z"
            transform="translate(-272.013 -286.819)"
          />
        </g>
      </g>
    </svg>
  );
};
export const ReadSMSIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = theme.palette.grey[600] } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 55.108 55.119">
      <defs>
        <style>.a{fill}</style>
      </defs>
      <g transform="translate(-287.333 -288.418)">
        <g transform="translate(287.333 288.418)">
          <g transform="translate(0 0)">
            <path
              fill={fill}
              className="a"
              d="M313.439,329.574a15.328,15.328,0,0,1,0-30.656,1.7,1.7,0,1,1,0,3.406,11.922,11.922,0,1,0,11.922,11.922,1.7,1.7,0,1,1,3.406,0A15.345,15.345,0,0,1,313.439,329.574Z"
              transform="translate(-274.27 -275.075)"
            />
            <path
              fill={fill}
              className="a"
              d="M308.67,316.74a3.384,3.384,0,0,1-2.4-.992l-3.9-3.908a1.7,1.7,0,0,1,2.409-2.407l3.9,3.9,12.424-12.417a1.7,1.7,0,0,1,2.409,2.407l-12.424,12.419a3.372,3.372,0,0,1-2.407,1Z"
              transform="translate(-269.503 -273.168)"
            />
            <path
              fill={fill}
              className="a"
              d="M296.127,342.917a1.7,1.7,0,0,1-1.7-1.7V332.7h-1.7a5.116,5.116,0,0,1-5.109-5.109V293.527a5.114,5.114,0,0,1,5.109-5.109H337a5.114,5.114,0,0,1,5.109,5.109v17.031a1.7,1.7,0,0,1-3.406,0V293.527a1.705,1.705,0,0,0-1.7-1.7h-44.28a1.7,1.7,0,0,0-1.7,1.7v34.062a1.705,1.705,0,0,0,1.7,1.7h3.406a1.7,1.7,0,0,1,1.7,1.7v6.815l7.432-5.566a1.7,1.7,0,0,1,2.044,2.727l-10.157,7.607A1.724,1.724,0,0,1,296.127,342.917Z"
              transform="translate(-287.612 -288.418)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
export const UnreadSMSIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = theme.palette.grey[600] } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 55.108 55.119">
      <defs>
        <style>.a{fill}</style>
      </defs>
      <g transform="translate(-294.216 -290.419)">
        <g transform="translate(9.039 7.293)">
          <g transform="translate(285.177 283.126)">
            <path
              fill={fill}
              className="a"
              d="M292.739,331.523a1.51,1.51,0,0,1-1.512-1.512v-7.562h-1.512a4.543,4.543,0,0,1-4.537-4.537V287.663a4.541,4.541,0,0,1,4.537-4.537h39.322a4.543,4.543,0,0,1,4.537,4.537v21.173a1.512,1.512,0,1,1-3.025,0V287.663a1.514,1.514,0,0,0-1.512-1.512H289.714a1.513,1.513,0,0,0-1.512,1.512v30.248a1.513,1.513,0,0,0,1.512,1.512h3.025a1.513,1.513,0,0,1,1.512,1.512v6.052l6.6-4.943a1.513,1.513,0,0,1,1.813,2.422l-9.02,6.755A1.52,1.52,0,0,1,292.739,331.523Z"
              transform="translate(-285.177 -283.126)"
            />
            <path
              fill={fill}
              className="a"
              d="M303.189,306.45a1.513,1.513,0,0,1-1.512-1.512v-6.05a1.512,1.512,0,1,1,3.025,0v6.05A1.513,1.513,0,0,1,303.189,306.45Z"
              transform="translate(-268.404 -268.641)"
            />
            <path
              fill={fill}
              className="a"
              d="M300.763,320.848a5.1,5.1,0,0,1-5.088-5.082,5.161,5.161,0,0,1,.54-2.289l8.52-17.04a5.093,5.093,0,0,1,9.109,0l8.52,17.044h0a5.089,5.089,0,0,1-4.553,7.366H300.763Zm8.53-24.2a2.066,2.066,0,0,0-1.851,1.141l-8.52,17.042a2.023,2.023,0,0,0-.222.93,2.067,2.067,0,0,0,2.065,2.061H317.81a2.126,2.126,0,0,0,.93-.218,2.07,2.07,0,0,0,.917-2.773l-8.52-17.042a2.064,2.064,0,0,0-1.845-1.141Z"
              transform="translate(-274.506 -272.452)"
            />
            <circle className="a" cx="2" cy="2" r="2" transform="translate(33.119 39.633)" />
          </g>
        </g>
      </g>
    </svg>
  );
};
export const NoCallActivityIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = defaultIconColor } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 23.541 22.561">
      <defs>
        <style>{`.NoCallActivityIcon{fill:${fill}}`}</style>
      </defs>
      <g transform="translate(-20.432 0.061)">
        <path
          className="NoCallActivityIcon"
          d="M10.68,5.418A.749.749,0,0,0,10.07,6.6l3.064,4.3a1.534,1.534,0,0,0,1.247.641,1.518,1.518,0,0,0,.885-.283l1.87-1.333.018,0a.023.023,0,0,1,.02.009l2.335,3.275-1.67-.28a.75.75,0,0,0-.248,1.479l3.456.579a.555.555,0,0,0,.082.008c.014,0,.032,0,.05,0a.76.76,0,0,0,.54-.238c.009-.01.023-.027.032-.039a.718.718,0,0,0,.057-.078l.031-.057c.013-.025.022-.045.031-.066a.677.677,0,0,0,.031-.106.424.424,0,0,0,.01-.046l.578-3.451a.752.752,0,0,0-.615-.864.761.761,0,0,0-.125-.01.748.748,0,0,0-.739.626l-.28,1.671L18.4,9.07A1.529,1.529,0,0,0,16.272,8.7l-1.879,1.339-.019,0a.023.023,0,0,1-.021-.01l-3.063-4.3A.745.745,0,0,0,10.68,5.418Z"
          transform="translate(21.475 -4.992)"
        />
        <path
          className="NoCallActivityIcon"
          d="M329.038,363a5.986,5.986,0,0,1-3.222-.946l-.03-.021a46.822,46.822,0,0,1-12.658-12.657,6.023,6.023,0,0,1,.8-7.472l.718-.717a2.565,2.565,0,0,1,3.624,0l3.021,3.019a2.566,2.566,0,0,1,0,3.627.853.853,0,0,0,0,1.206l4.834,4.834a.853.853,0,0,0,1.208,0,2.57,2.57,0,0,1,3.626,0l3.02,3.021a2.565,2.565,0,0,1,0,3.625l-.717.717A5.953,5.953,0,0,1,329.038,363Zm-12.583-20.853a.852.852,0,0,0-.6.25l-.718.717a4.3,4.3,0,0,0-.582,5.316,45.112,45.112,0,0,0,12.193,12.19l.011.008.01.008a4.237,4.237,0,0,0,5.286-.6l.718-.717a.856.856,0,0,0,0-1.21l-3.02-3.02a.855.855,0,0,0-1.209,0,2.568,2.568,0,0,1-3.626,0l-4.835-4.834a2.57,2.57,0,0,1,0-3.625.853.853,0,0,0,0-1.208l-3.021-3.021A.852.852,0,0,0,316.456,342.143Z"
          transform="translate(-291.754 -340.496)"
        />
      </g>
    </svg>
  );
};
export const NoSMSActivityIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = defaultIconColor } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 23.543 22">
      <defs>
        <style>{`.NoSMSActivityIcon{fill:${fill}}`}</style>
      </defs>
      <g transform="translate(-20.43 0.061)">
        <path
          className="NoSMSActivityIcon"
          d="M10.68,5.418A.749.749,0,0,0,10.07,6.6l3.064,4.3a1.534,1.534,0,0,0,1.247.641,1.518,1.518,0,0,0,.885-.283l1.87-1.333.018,0a.023.023,0,0,1,.02.009l2.335,3.275-1.67-.28a.75.75,0,0,0-.248,1.479l3.456.579a.555.555,0,0,0,.082.008c.014,0,.032,0,.05,0a.76.76,0,0,0,.54-.238c.009-.01.023-.027.032-.039a.718.718,0,0,0,.057-.078l.031-.057c.013-.025.022-.045.031-.066a.677.677,0,0,0,.031-.106.424.424,0,0,0,.01-.046l.578-3.451a.752.752,0,0,0-.615-.864.761.761,0,0,0-.125-.01.748.748,0,0,0-.739.626l-.28,1.671L18.4,9.07A1.529,1.529,0,0,0,16.272,8.7l-1.879,1.339-.019,0a.023.023,0,0,1-.021-.01l-3.063-4.3A.745.745,0,0,0,10.68,5.418Z"
          transform="translate(21.475 5.501)"
        />
        <path
          className="NoSMSActivityIcon"
          d="M291.049,310.418a.686.686,0,0,1-.687-.687v-3.437h-.687a2.065,2.065,0,0,1-2.062-2.062V290.48a2.064,2.064,0,0,1,2.063-2.063h17.875a2.064,2.064,0,0,1,2.063,2.063v6.875a.688.688,0,0,1-1.375,0V290.48a.688.688,0,0,0-.687-.687H289.674a.688.688,0,0,0-.687.688v13.75a.688.688,0,0,0,.688.688h1.375a.688.688,0,0,1,.688.688v2.751l3-2.247a.688.688,0,0,1,.825,1.1l-4.1,3.071A.7.7,0,0,1,291.049,310.418Z"
          transform="translate(-267.182 -288.479)"
        />
      </g>
    </svg>
  );
};
export const AllActivitiesIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = defaultIconColor } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24.017 22.5"
      {...props}
    >
      <defs>
        <style>{`.AllActivitiesIcon{fill${fill}}`}</style>
      </defs>
      <path
        className="AllActivitiesIcon"
        d="M12.002 13.499a2.3 2.3 0 01-1.051-.254L.74 7.963a1.366 1.366 0 010-2.427L10.946.256a2.3 2.3 0 012.105 0l10.211 5.282a1.366 1.366 0 010 2.426l-10.209 5.281a2.3 2.3 0 01-1.051.254zM1.633 6.764l10.006 5.148a.8.8 0 00.728 0l9.977-5.161-9.98-5.162a.8.8 0 00-.727 0zm20.941.1z"
      />
      <path
        className="AllActivitiesIcon"
        d="M12.009 18a2.315 2.315 0 01-1.056-.255L.443 12.676a.75.75 0 01.651-1.352l10.528 5.078a.809.809 0 00.747.009l10.575-5.087a.75.75 0 01.65 1.352L13.035 17.75a2.244 2.244 0 01-1.026.25z"
      />
      <path
        className="AllActivitiesIcon"
        d="M12.009 22.5a2.315 2.315 0 01-1.056-.255L.443 17.176a.75.75 0 01.651-1.352l10.528 5.078a.812.812 0 00.747.009l10.575-5.087a.75.75 0 01.65 1.352L13.035 22.25a2.244 2.244 0 01-1.026.25z"
      />
    </svg>
  );
};
export const NoActivityIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = defaultIconColor } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24.75 22.33"
      {...props}
    >
      <path
        d="M.751 11.5h6.645l2.106-5.612 3.756 12.857 4.852-18 3.256 19.705"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="M21.344 21.96a.821.821 0 01-.242-.073.524.524 0 01-.052-.028l-.02-.011-.019-.012-.04-.03-3.223-2.301a.834.834 0 01-.345-.546.848.848 0 01.953-.984.853.853 0 01.373.148l1.56 1.116-.49-2.95 1.758.247.404 2.424 1.115-1.56a.839.839 0 01.805-.348.854.854 0 01.256.078.637.637 0 01.12.073.849.849 0 01.2 1.182l-2.299 3.221c-.001.01-.011.017-.019.026l-.014.019-.012.012c-.02.023-.042.047-.07.073l-.03.027-.017.013-.016.014a1.05 1.05 0 01-.061.04.505.505 0 01-.084.047l-.013.006h-.006a.294.294 0 01-.045.02.866.866 0 01-.427.056z"
        fill={fill}
      />
    </svg>
  );
};
export const NoInventoryIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = defaultIconColor } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 31.54 22.074"
      {...props}
    >
      <defs>
        <style>{`.prefix__a{fill:${fill}`}</style>
      </defs>
      <path
        className="prefix__a"
        d="M19.721 0a.749.749 0 00-.61 1.182l3.064 4.3a1.534 1.534 0 001.247.641 1.518 1.518 0 00.885-.283l1.87-1.333h.018a.023.023 0 01.02.009l2.335 3.275-1.67-.28a.75.75 0 00-.248 1.479l3.456.579a.555.555 0 00.082.008h.05a.76.76 0 00.54-.238.669.669 0 00.032-.039.718.718 0 00.057-.078l.031-.057a.92.92 0 00.031-.066.677.677 0 00.031-.106.424.424 0 00.01-.046l.578-3.451a.752.752 0 00-.615-.864.761.761 0 00-.125-.01.748.748 0 00-.739.626l-.28 1.671-2.33-3.267a1.529 1.529 0 00-2.128-.37l-1.879 1.339h-.019a.023.023 0 01-.021-.01l-3.063-4.3a.745.745 0 00-.61-.311zM14.584 22.074a2.819 2.819 0 01-1.97-.854 2.8 2.8 0 01-1.957.854h-7.9A2.809 2.809 0 010 19.221v-6.134a2.8 2.8 0 012.743-2.838h2.775V2.838A2.8 2.8 0 018.262 0h7.9a2.8 2.8 0 012.758 2.854v7.395h3.548a2.8 2.8 0 012.759 2.851v6.133a2.8 2.8 0 01-2.743 2.838h-7.9zM13.4 19.236a1.231 1.231 0 001.2 1.264h7.868a1.221 1.221 0 001.183-1.246v-6.167a1.234 1.234 0 00-.341-.887 1.212 1.212 0 00-.857-.374h-1.167v4.73a.789.789 0 01-.788.788h-3.942a.789.789 0 01-.789-.788v-4.73H13.4zM2.763 11.825a1.222 1.222 0 00-1.187 1.247v6.164A1.231 1.231 0 002.775 20.5h7.868a1.217 1.217 0 001.183-1.246v-7.429H9.46v4.73a.789.789 0 01-.788.788H4.73a.789.789 0 01-.788-.788v-4.73zm16.945 3.942v-3.942h-2.364v3.942zm-11.825 0v-3.942H5.518v3.942zm9.46-5.518V2.838A1.228 1.228 0 0017 1.952a1.214 1.214 0 00-.858-.375h-1.163v4.73a.789.789 0 01-.788.788h-3.942a.789.789 0 01-.788-.788v-4.73H8.282A1.222 1.222 0 007.1 2.823v7.425zM13.4 5.518V1.577h-2.363v3.941z"
      />
    </svg>
  );
};
export const GpacUIcon = ({
  size = defaultIconSize,
  fill = theme.palette.grey[600],
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="prefix__Layer_1"
      width={size}
      height={size}
      viewBox="0 0 600 600"
      xmlSpace="preserve"
      {...rest}
    >
      <style>
        {`.prefix__st0{fill:none;stroke:${fill};stroke-width:25;stroke-linecap:round;stroke-linejoin:round}`}
      </style>
      <path
        id="prefix__Shape_545_1_"
        className="prefix__st0"
        d="M500 350V133.3c0-18.4-14.9-33.3-33.3-33.3H133.3c-18.4 0-33.3 14.9-33.3 33.3V350h400z"
      />
      <path
        id="prefix__Shape_546_1_"
        className="prefix__st0"
        d="M547.1 453.1c4.6 10.3 3.6 22.2-2.5 31.7s-16.7 15.2-28 15.2H83.3c-11.3 0-21.8-5.7-28-15.2-6.2-9.5-7.1-21.4-2.5-31.7L100 350h400l47.1 103.1z"
      />
      <path id="prefix__Shape_547_1_" className="prefix__st0" d="M266.7 433.3h66.7" />
      <g>
        <path
          id="prefix__Shape_365_1_"
          className="prefix__st0"
          d="M354.5 211.4v72L300 300l-54.5-16.7v-72"
        />
        <path
          id="prefix__Shape_366_1_"
          className="prefix__st0"
          d="M410 190.9L300 150l-110 40.9 110 40.9 110-40.9z"
        />
        <path id="prefix__Shape_367_1_" className="prefix__st0" d="M190 192.6v35" />
      </g>
    </svg>
  );
};
export const RingCentralIcon = ({ size = defaultIconSize, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 90 90"
      fill="none"
      {...rest}
    >
      <g clipPath="url(#RingCentral)">
        <path
          d="M.02 89.984v-1.042C.02 59.544.012 30.147 0 .75 0 .088.176-.002.775 0 30.257.016 59.74.016 89.221 0c.603 0 .779.084.779.749-.023 29.485-.023 58.97 0 88.455 0 .683-.176.796-.82.796-29.717-.018-59.437-.023-89.16-.016zm52.533-11.25H77.15c1.52 0 1.582-.063 1.582-1.582v-43.84c0-2.782-.028-5.57-.527-8.312-1.135-6.13-4.591-10.372-10.48-12.518-3.073-1.125-6.307-1.199-9.524-1.213-8.789-.036-17.573-.036-26.353 0-2.285 0-4.57.092-6.819.51-6.152 1.139-10.353 4.607-12.533 10.471-1.086 2.925-1.202 6.009-1.214 9.08-.032 8.261 0 16.523-.014 24.785 0 2.606.09 5.203.337 7.802.63 6.603 5.296 12.224 11.693 13.952 2.821.761 5.722.856 8.613.869 6.879.019 13.76 0 20.642 0v-.004z"
          fill="#FE8000"
        />
        <path
          d="M52.553 78.738c-6.881 0-13.763.019-20.643-.01-2.897-.011-5.801-.106-8.614-.867-6.396-1.728-11.063-7.35-11.693-13.952-.248-2.6-.339-5.196-.337-7.803 0-8.262-.018-16.524.014-24.785.012-3.071.128-6.153 1.215-9.08 2.18-5.863 6.388-9.332 12.533-10.47 2.255-.419 4.537-.505 6.818-.51 8.79-.023 17.574-.023 26.354 0 3.216.014 6.45.087 9.523 1.212 5.889 2.154 9.345 6.388 10.48 12.518.507 2.742.528 5.53.528 8.313v43.84c0 1.518-.064 1.581-1.582 1.581l-24.596.013zm-13.916-10.36c0-.068 0-.136-.02-.175a10.14 10.14 0 00-.425-.559c-3.312-4.1-5.054-8.789-5.098-14.05-.06-6.59-.008-13.184-.03-19.768 0-.602.134-.793.767-.791 7.467.02 14.935.02 22.403 0 .593 0 .723.186.72.743-.025 3.22-.032 6.443 0 9.668 0 .679-.157.879-.86.879-3.047-.04-6.091-.014-9.141-.02-.397 0-.738-.04-.733.56.023 2.928 0 5.857.021 8.789 0 .857.608 1.545 1.376 1.524.623-.018.855.286 1.12.749 2.259 3.953 4.548 7.887 6.8 11.845.318.558.688.739 1.321.732 3.192-.034 6.385-.014 9.577-.014 1.17 0 1.155 0 .606-.986-2.223-4.044-4.428-8.086-6.66-12.12-.269-.487-.274-.704.315-.9a12.92 12.92 0 002.904-1.416c2.84-1.84 4.867-4.26 4.921-7.803.08-5.563.043-11.128.014-16.699a7.121 7.121 0 00-7.168-7.107H28.422c-3.813 0-6.964 3.198-6.964 7.007 0 8.64-.003 17.28-.01 25.919a21.06 21.06 0 00.363 4.361c.703 3.373 1.934 6.485 4.475 8.944.547.527 1.118.826 1.934.812 3.164-.05 6.328-.016 9.492-.025.304-.005.633.092.925-.098z"
          fill="#FEFEFE"
        />
        <path
          d="M38.637 68.379c-.292.19-.62.093-.93.095-3.164 0-6.328-.025-9.492.024-.818.014-1.39-.283-1.934-.812-2.54-2.46-3.767-5.57-4.475-8.943a21.063 21.063 0 01-.359-4.369c.015-8.64.018-17.28.009-25.919 0-3.809 3.152-7 6.964-7.006 10.98-.01 21.962-.01 32.945 0a7.122 7.122 0 017.169 7.107c.028 5.565.065 11.13-.015 16.699-.049 3.542-2.076 5.962-4.921 7.803a12.911 12.911 0 01-2.895 1.415c-.59.197-.584.413-.315.9 2.232 4.032 4.437 8.086 6.66 12.12.549.993.564.986-.606.986-3.192 0-6.385-.02-9.577.014-.633 0-1.004-.176-1.322-.731-2.251-3.959-4.54-7.893-6.799-11.846-.265-.462-.497-.766-1.12-.749-.768.021-1.369-.666-1.376-1.524-.025-2.928 0-5.857-.021-8.789 0-.6.336-.559.733-.559 3.046 0 6.09-.021 9.14.02.704.01.867-.196.86-.88a492.988 492.988 0 010-9.667c0-.558-.127-.746-.719-.744-7.467.021-14.935.021-22.403 0-.633 0-.768.19-.767.791.022 6.588-.03 13.184.03 19.768.048 5.261 1.79 9.951 5.098 14.05.148.176.29.368.425.56.021.049.007.117.013.186z"
          fill="#0186C1"
        />
      </g>
      <defs>
        <clipPath id="RingCentral">
          <path fill="#fff" d="M0 0h90v90H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PlacementsPendingApprovalIcon = ({
  size = defaultIconSize,
  fill = defaultIconColor,
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      {...rest}
    >
      <defs>
        <style>{`.PlacementsPendingApprovalIcon{fill:${fill}}`}</style>
      </defs>
      <path
        className="PlacementsPendingApprovalIcon"
        d="M1.022 10.178a.727.727 0 01-.172-.02.749.749 0 01-.558-.9A12.133 12.133 0 011.45 6.222a.75.75 0 011.317.717 10.674 10.674 0 00-1.015 2.664.751.751 0 01-.73.575zM4.15 4.671a.75.75 0 01-.518-1.293 12.926 12.926 0 012.607-1.922.75.75 0 01.731 1.309 11.411 11.411 0 00-2.3 1.7.748.748 0 01-.52.206zM10.971 23.954h-.067a11.841 11.841 0 01-3.171-.727.75.75 0 11.533-1.4 10.383 10.383 0 002.77.636.75.75 0 01-.065 1.5zM5.075 21.637a.75.75 0 01-.456-.155 11.569 11.569 0 01-2.279-2.33.75.75 0 011.209-.887 10.056 10.056 0 001.984 2.027.75.75 0 01-.458 1.345zM1.363 16.503a.751.751 0 01-.705-.5 11.256 11.256 0 01-.654-3.193.751.751 0 011.5-.086 9.774 9.774 0 00.57 2.771.749.749 0 01-.7 1.006zM14.213 23.779a.75.75 0 01-.149-1.485 10.5 10.5 0 003.691-19.051 10.441 10.441 0 00-7.892-1.528.75.75 0 01-.3-1.47 12 12 0 0112.414 18.378 11.93 11.93 0 01-7.613 5.142.772.772 0 01-.151.014z"
      />
      <path
        className="PlacementsPendingApprovalIcon"
        d="M11.72 20.2a8.184 8.184 0 118.184-8.184A8.193 8.193 0 0111.72 20.2zm0-14.549a6.365 6.365 0 106.365 6.365 6.372 6.372 0 00-6.365-6.364z"
      />
      <path
        className="PlacementsPendingApprovalIcon"
        d="M14.124 14.092h-2.653a.75.75 0 01-.75-.75V10.69a.75.75 0 111.5 0v1.9h1.9a.75.75 0 010 1.5z"
      />
    </svg>
  );
};

export const PlacementsPendingInvoiceIcon = ({
  size = defaultIconSize,
  fill = defaultIconColor,
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      {...rest}
    >
      <defs>
        <style>{`.PendingInvoicedIcon{fill:${fill}}`}</style>
      </defs>
      <path
        className="PendingInvoicedIcon"
        d="M12.004 20.203a8.259 8.259 0 01-8.25-8.25.75.75 0 011.5 0 6.75 6.75 0 106.75-6.75.75.75 0 010-1.5 8.25 8.25 0 010 16.5zM1.022 10.178a.727.727 0 01-.172-.02.749.749 0 01-.558-.9A12.133 12.133 0 011.45 6.222a.75.75 0 011.317.717 10.674 10.674 0 00-1.015 2.664.751.751 0 01-.73.575zM4.15 4.671a.75.75 0 01-.518-1.293 12.926 12.926 0 012.607-1.922.75.75 0 01.731 1.309 11.411 11.411 0 00-2.3 1.7.748.748 0 01-.52.206zM10.971 23.954h-.067a11.841 11.841 0 01-3.171-.727.75.75 0 11.533-1.4 10.383 10.383 0 002.77.636.75.75 0 01-.065 1.5zM5.075 21.637a.75.75 0 01-.456-.155 11.569 11.569 0 01-2.279-2.33.75.75 0 011.209-.887 10.056 10.056 0 001.984 2.027.75.75 0 01-.458 1.345zM1.363 16.503a.751.751 0 01-.705-.5 11.256 11.256 0 01-.654-3.193.751.751 0 011.5-.086 9.774 9.774 0 00.57 2.771.749.749 0 01-.7 1.006z"
      />
      <path
        className="PendingInvoicedIcon"
        d="M14.213 23.779a.75.75 0 01-.149-1.485 10.5 10.5 0 003.691-19.051 10.441 10.441 0 00-7.892-1.528.75.75 0 01-.3-1.47 12 12 0 0112.414 18.378 11.93 11.93 0 01-7.613 5.142.772.772 0 01-.151.014z"
      />
      <path
        className="PendingInvoicedIcon"
        d="M11.504 15.703a.75.75 0 01-.531-.219l-3-3a.75.75 0 011.061-1.06l2.389 2.389 3.981-5.31a.75.75 0 011.2.9l-4.5 6a.752.752 0 01-.547.3z"
      />
    </svg>
  );
};

export const PlacementsInvoicedIcon = ({
  size = defaultIconSize,
  fill = defaultIconColor,
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      width={size}
      height={size}
      viewBox="0 0 24 23.962"
      {...rest}
    >
      <defs>
        <style>{`.InvoicedIcon{fill:${fill}}`}</style>
      </defs>
      <path
        className="InvoicedIcon"
        d="M18.75 24H2.25A2.252 2.252 0 010 21.75V2.25A2.252 2.252 0 012.25 0h10.629a2.238 2.238 0 011.59.658l5.872 5.873A2.235 2.235 0 0121 8.121V21.75A2.252 2.252 0 0118.75 24zM2.25 1.5a.751.751 0 00-.75.75v19.5a.752.752 0 00.75.75h16.5a.751.751 0 00.75-.75V8.121a.755.755 0 00-.22-.53l-5.871-5.872a.758.758 0 00-.53-.219z"
      />
      <path
        className="InvoicedIcon"
        d="M20.25 9h-6A2.252 2.252 0 0112 6.75v-6a.75.75 0 011.5 0v6a.752.752 0 00.75.75h6a.75.75 0 110 1.5zM6.445 13.222a2.966 2.966 0 01-2.341-1.173.75.75 0 111.193-.909 1.473 1.473 0 001.232.58c.8 0 1.342-.421 1.342-.8s-.537-.8-1.309-.8a2.345 2.345 0 110-4.6 2.945 2.945 0 012.455 1.172.75.75 0 01-1.194.907 1.48 1.48 0 00-1.231-.579c-.8 0-1.342.42-1.342.8s.539.8 1.312.8a2.344 2.344 0 110 4.593.594.594 0 01-.117.009z"
      />
      <path
        className="InvoicedIcon"
        d="M6.562 14.25a.75.75 0 01-.75-.75v-1.029a.75.75 0 011.5 0v1.031a.75.75 0 01-.75.748zM6.562 7.031a.75.75 0 01-.75-.75V5.25a.75.75 0 011.5 0v1.031a.75.75 0 01-.75.75zM16.5 15.75h-6a.75.75 0 010-1.5h6a.75.75 0 110 1.5zM16.5 20.25H5.25a.75.75 0 010-1.5H16.5a.75.75 0 110 1.5z"
      />
    </svg>
  );
};

export const PlacementsFallOffIcon = ({
  size = defaultIconSize,
  fill = defaultIconColor,
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      width={size}
      height={size}
      viewBox="0 0 24 23.962"
      {...rest}
    >
      <defs>
        <style>{`.FallOffIcon{fill:${fill}}`}</style>
      </defs>
      <path
        className="FallOffIcon"
        d="M5.242 7.488a3.744 3.744 0 113.744-3.744 3.744 3.744 0 01-3.744 3.744zm0-5.99a2.247 2.247 0 102.246 2.246 2.247 2.247 0 00-2.246-2.246z"
      />
      <path
        className="FallOffIcon"
        d="M2.995 23.962a.746.746 0 01-.745-.674l-.681-6.814h-.82A.749.749 0 010 15.725V12.73a5.242 5.242 0 019.832-2.533.747.747 0 01-.655 1.11.748.748 0 01-.656-.387 3.745 3.745 0 00-7.023 1.81v2.247h.748a.745.745 0 01.749.673l.678 6.815h3.138l.442-4.418a.744.744 0 01.734-.674.632.632 0 01.086 0 .749.749 0 01.665.819l-.509 5.092a.745.745 0 01-.741.678zM19.109 17.34a.67.67 0 01.324-1.3l1.68.419-3.7-6.159-2.1 1.262a1.339 1.339 0 01-1.838-.457l-2.582-4.3a.67.67 0 111.147-.69l2.583 4.3 2.1-1.262a1.338 1.338 0 011.836.456l3.7 6.159.418-1.68a.67.67 0 111.3.324l-.81 3.249a.643.643 0 01-.1.214l-.009.013a.677.677 0 01-.447.274h-.025a.638.638 0 01-.234-.016z"
      />
    </svg>
  );
};

export const MicrosoftLoginButtonIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="215"
    height="41"
    style={{ cursor: 'pointer' }}
    {...props}
  >
    <path fill="#2f2f2f" d="M0 0h215v41H0z" />
    <path
      fill="#ffffff"
      d="M45.812 25.082v-1.794a2.77 2.77 0 0 0 .573.4 4.484 4.484 0 0 0 .706.3 5.486 5.486 0 0 0 .745.187 3.954 3.954 0 0 0 .687.065 2.928 2.928 0 0 0 1.634-.365 1.2 1.2 0 0 0 .537-1.062 1.167 1.167 0 0 0-.178-.649 1.939 1.939 0 0 0-.5-.5 5.412 5.412 0 0 0-.757-.435q-.435-.209-.932-.436-.533-.285-.994-.578a4.285 4.285 0 0 1-.8-.648 2.724 2.724 0 0 1-.533-.8 2.6 2.6 0 0 1-.194-1.047 2.416 2.416 0 0 1 .333-1.285 2.794 2.794 0 0 1 .877-.9 4.019 4.019 0 0 1 1.239-.528 5.906 5.906 0 0 1 1.418-.172 5.692 5.692 0 0 1 2.4.374v1.721a3.817 3.817 0 0 0-2.295-.645 4.093 4.093 0 0 0-.771.074 2.335 2.335 0 0 0-.687.241 1.5 1.5 0 0 0-.494.433 1.06 1.06 0 0 0-.189.637 1.221 1.221 0 0 0 .145.608 1.573 1.573 0 0 0 .428.468 4.321 4.321 0 0 0 .688.414c.27.134.584.28.939.436q.548.285 1.034.6a4.881 4.881 0 0 1 .856.7 3.075 3.075 0 0 1 .585.846 2.493 2.493 0 0 1 .215 1.058 2.625 2.625 0 0 1-.322 1.348 2.584 2.584 0 0 1-.866.892 3.786 3.786 0 0 1-1.254.5 6.959 6.959 0 0 1-1.5.155c-.176 0-.392-.014-.647-.04s-.518-.067-.786-.117a7.75 7.75 0 0 1-.76-.187 2.373 2.373 0 0 1-.58-.269zM55.109 16.426a1.021 1.021 0 0 1-.713-.272.891.891 0 0 1-.3-.688.917.917 0 0 1 .3-.7 1.009 1.009 0 0 1 .713-.278 1.041 1.041 0 0 1 .732.278.915.915 0 0 1 .3.7.9.9 0 0 1-.3.678 1.035 1.035 0 0 1-.732.282zm.841 9.074h-1.7V18h1.7zM64.979 24.9q0 4.131-4.146 4.131a6.166 6.166 0 0 1-2.551-.491v-1.554a4.712 4.712 0 0 0 2.332.7 2.341 2.341 0 0 0 2.668-2.628v-.818h-.029a2.938 2.938 0 0 1-4.733.436 4.046 4.046 0 0 1-.837-2.684 4.738 4.738 0 0 1 .9-3.04 2.988 2.988 0 0 1 2.471-1.128 2.38 2.38 0 0 1 2.2 1.216h.029V18h1.7zM63.3 22.064v-.973a1.91 1.91 0 0 0-.523-1.352 1.71 1.71 0 0 0-1.3-.559 1.789 1.789 0 0 0-1.51.714 3.223 3.223 0 0 0-.545 2 2.78 2.78 0 0 0 .523 1.769 1.675 1.675 0 0 0 1.385.662 1.8 1.8 0 0 0 1.426-.632 2.4 2.4 0 0 0 .544-1.629zM73.853 25.5h-1.7v-4.227q0-2.1-1.483-2.1a1.616 1.616 0 0 0-1.279.582 2.167 2.167 0 0 0-.505 1.469V25.5h-1.7V18h1.7v1.245h.029a2.669 2.669 0 0 1 2.428-1.421 2.257 2.257 0 0 1 1.863.795 3.57 3.57 0 0 1 .644 2.3zM80.892 16.426a1.017 1.017 0 0 1-.713-.272.889.889 0 0 1-.3-.688.915.915 0 0 1 .3-.7 1 1 0 0 1 .713-.278 1.038 1.038 0 0 1 .731.278.915.915 0 0 1 .3.7.9.9 0 0 1-.3.678 1.033 1.033 0 0 1-.731.282zm.84 9.074h-1.7V18h1.7zM90.614 25.5h-1.7v-4.227q0-2.1-1.483-2.1a1.62 1.62 0 0 0-1.28.582 2.167 2.167 0 0 0-.5 1.469V25.5h-1.7V18h1.7v1.245h.03a2.668 2.668 0 0 1 2.427-1.421 2.258 2.258 0 0 1 1.864.795 3.576 3.576 0 0 1 .643 2.3zM106.865 18l-2.208 7.5h-1.776l-1.36-5.083a3.291 3.291 0 0 1-.1-.659h-.029a3.018 3.018 0 0 1-.132.644l-1.477 5.1h-1.741l-2.2-7.5H97.6l1.36 5.405a3.308 3.308 0 0 1 .087.645h.053a3.384 3.384 0 0 1 .117-.659L100.725 18h1.593l1.345 5.428a3.832 3.832 0 0 1 .095.644h.052a3.3 3.3 0 0 1 .109-.644l1.33-5.428zM108.977 16.426a1.017 1.017 0 0 1-.713-.272.889.889 0 0 1-.3-.688.915.915 0 0 1 .3-.7 1 1 0 0 1 .713-.278 1.038 1.038 0 0 1 .731.278.915.915 0 0 1 .3.7.9.9 0 0 1-.3.678 1.033 1.033 0 0 1-.731.282zm.84 9.074h-1.7V18h1.7zM115.979 25.42a2.944 2.944 0 0 1-1.307.248q-2.18 0-2.179-2.094v-4.241h-1.25V18h1.25v-1.736l1.7-.483V18h1.79v1.333h-1.79v3.75a1.478 1.478 0 0 0 .242.952 1 1 0 0 0 .8.285 1.16 1.16 0 0 0 .745-.248zM124.094 25.5h-1.7v-4.1q0-2.226-1.483-2.226a1.555 1.555 0 0 0-1.258.644 2.573 2.573 0 0 0-.511 1.649V25.5h-1.7V14.4h1.7v4.849h.029a2.679 2.679 0 0 1 2.428-1.421q2.492 0 2.492 3.055zM141.719 25.5h-1.726v-6.8q0-.835.1-2.043h-.03a6.992 6.992 0 0 1-.285.988l-3.126 7.855h-1.2l-3.136-7.793a7.371 7.371 0 0 1-.277-1.047h-.029q.059.63.058 2.058V25.5h-1.608V15h2.449l2.756 7a10.415 10.415 0 0 1 .409 1.2h.036c.181-.551.327-.962.439-1.23l2.808-6.97h2.362zM144.964 16.426a1.019 1.019 0 0 1-.713-.272.892.892 0 0 1-.3-.688.918.918 0 0 1 .3-.7 1.007 1.007 0 0 1 .713-.278 1.038 1.038 0 0 1 .731.278.911.911 0 0 1 .3.7.9.9 0 0 1-.3.678 1.033 1.033 0 0 1-.731.282zm.841 9.074h-1.7V18h1.7zM153.378 25.156a4.185 4.185 0 0 1-2.127.52 3.6 3.6 0 0 1-2.69-1.044 3.7 3.7 0 0 1-1.024-2.706 4.074 4.074 0 0 1 1.1-2.978 3.93 3.93 0 0 1 2.942-1.124 4.281 4.281 0 0 1 1.806.36v1.582a2.73 2.73 0 0 0-1.667-.586 2.312 2.312 0 0 0-1.762.728 2.669 2.669 0 0 0-.687 1.908 2.54 2.54 0 0 0 .647 1.838 2.291 2.291 0 0 0 1.736.674 2.708 2.708 0 0 0 1.725-.652zM159.4 19.619a1.4 1.4 0 0 0-.884-.242 1.514 1.514 0 0 0-1.258.682 3.047 3.047 0 0 0-.5 1.852V25.5h-1.7V18h1.7v1.545h.029a2.6 2.6 0 0 1 .764-1.233 1.72 1.72 0 0 1 1.151-.444 1.425 1.425 0 0 1 .7.14zM163.788 25.676a3.71 3.71 0 0 1-2.767-1.051 3.8 3.8 0 0 1-1.035-2.787 3.7 3.7 0 0 1 3.985-4.014 3.581 3.581 0 0 1 2.733 1.033 3.994 3.994 0 0 1 .98 2.864 3.938 3.938 0 0 1-1.056 2.875 3.8 3.8 0 0 1-2.84 1.08zm.08-6.5a1.932 1.932 0 0 0-1.571.7 2.913 2.913 0 0 0-.578 1.919 2.744 2.744 0 0 0 .585 1.856 1.957 1.957 0 0 0 1.564.678 1.862 1.862 0 0 0 1.539-.666 2.95 2.95 0 0 0 .537-1.9 2.99 2.99 0 0 0-.537-1.911 1.851 1.851 0 0 0-1.539-.672zM168.94 25.266v-1.575a3.383 3.383 0 0 0 2.1.725q1.535 0 1.535-.908a.714.714 0 0 0-.132-.436 1.263 1.263 0 0 0-.354-.318 2.864 2.864 0 0 0-.526-.25c-.2-.072-.428-.155-.677-.248a7.074 7.074 0 0 1-.829-.389 2.526 2.526 0 0 1-.615-.465 1.758 1.758 0 0 1-.369-.59 2.168 2.168 0 0 1-.124-.769 1.775 1.775 0 0 1 .256-.955 2.224 2.224 0 0 1 .687-.7 3.294 3.294 0 0 1 .979-.425 4.49 4.49 0 0 1 1.129-.139 5.163 5.163 0 0 1 1.856.315v1.487a3.127 3.127 0 0 0-1.812-.542 2.323 2.323 0 0 0-.582.066 1.477 1.477 0 0 0-.442.183.893.893 0 0 0-.285.282.677.677 0 0 0-.1.363.779.779 0 0 0 .1.41.936.936 0 0 0 .3.3 2.675 2.675 0 0 0 .482.234q.282.105.648.23a9.5 9.5 0 0 1 .866.4 2.872 2.872 0 0 1 .654.465 1.789 1.789 0 0 1 .416.6 2.034 2.034 0 0 1 .147.81 1.855 1.855 0 0 1-.263 1 2.212 2.212 0 0 1-.7.7 3.28 3.28 0 0 1-1.013.413 5.2 5.2 0 0 1-1.209.136 5.1 5.1 0 0 1-2.123-.41zM179.183 25.676a3.711 3.711 0 0 1-2.768-1.051 3.8 3.8 0 0 1-1.034-2.787 3.7 3.7 0 0 1 3.984-4.014 3.585 3.585 0 0 1 2.734 1.033 3.993 3.993 0 0 1 .979 2.864 3.934 3.934 0 0 1-1.056 2.875 3.794 3.794 0 0 1-2.839 1.08zm.08-6.5a1.934 1.934 0 0 0-1.572.7 2.919 2.919 0 0 0-.578 1.919 2.749 2.749 0 0 0 .585 1.856 1.959 1.959 0 0 0 1.565.678 1.864 1.864 0 0 0 1.539-.666 2.956 2.956 0 0 0 .537-1.9 3 3 0 0 0-.537-1.911 1.852 1.852 0 0 0-1.539-.672zM188.787 15.781a1.523 1.523 0 0 0-.782-.2q-1.235 0-1.235 1.4V18h1.74v1.333h-1.733V25.5h-1.7v-6.167H183.8V18h1.279v-1.216a2.37 2.37 0 0 1 .775-1.871 2.817 2.817 0 0 1 1.937-.684 2.866 2.866 0 0 1 .994.138zM193.94 25.42a2.944 2.944 0 0 1-1.307.248q-2.179 0-2.179-2.094v-4.241H189.2V18h1.25v-1.736l1.7-.483V18h1.79v1.333h-1.79v3.75a1.472 1.472 0 0 0 .242.952 1 1 0 0 0 .8.285 1.162 1.162 0 0 0 .745-.248z"
    />
    <path fill="#f25022" d="M13 11h9v9h-9z" />
    <path fill="#00a4ef" d="M13 21h9v9h-9z" />
    <path fill="#7fba00" d="M23 11h9v9h-9z" />
    <path fill="#ffb900" d="M23 21h9v9h-9z" />
  </svg>
);
export const TotalCallTimeIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = theme.palette.grey[600] } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 55.11 55.119"
      {...props}
    >
      <defs>
        <style>{`.prefix__TotalCallTimeIcon{fill:${fill}}`}</style>
      </defs>
      <path
        className="prefix__TotalCallTimeIcon"
        d="M34 55.118a12.077 12.077 0 01-6.492-1.905l-.062-.044a94.41 94.41 0 01-25.507-25.5 12 12 0 011.6-15.059l1.446-1.446a5.172 5.172 0 017.3 0l6.088 6.086a5.163 5.163 0 010 7.307 1.724 1.724 0 000 2.433l9.738 9.74a1.722 1.722 0 002.436 0 5.175 5.175 0 017.307 0l6.09 6.086a5.171 5.171 0 010 7.307l-1.446 1.444A12 12 0 0134 55.118zM8.642 13.094a1.714 1.714 0 00-1.219.505l-1.446 1.444a8.556 8.556 0 00-1.173 10.711 90.97 90.97 0 0024.57 24.564l.025.016.021.016a8.544 8.544 0 0010.652-1.219l1.444-1.444a1.722 1.722 0 000-2.436l-6.09-6.086a1.719 1.719 0 00-2.433 0 5.177 5.177 0 01-7.307 0l-9.738-9.743a5.163 5.163 0 010-7.3 1.722 1.722 0 000-2.436L9.86 13.598a1.716 1.716 0 00-1.217-.504zM43.054 30.999c-6.423 0-12.055-4.944-12.055-10.579 0-6.427 3.109-10.579 7.922-10.579a1.722 1.722 0 011.7 2.018c-.119.689-.487 2.785-.172 3.162a1.465 1.465 0 00.8.133.794.794 0 00.854-.5c.84-1.7-.048-6.919-3.855-11.89A1.722 1.722 0 0139.61.005c7.387 0 15.5 9.141 15.5 17.468 0 9.972-6.228 13.526-12.056 13.526zm-6.163-17.125c-1.552 1.029-2.448 3.366-2.448 6.547 0 3.734 4.1 7.134 8.611 7.134 2.588 0 8.611-.983 8.611-10.087 0-4.73-3.867-10.524-8.225-12.916 2.312 4.452 3.043 9.011 1.747 11.633a4.244 4.244 0 01-3.94 2.416 4.243 4.243 0 01-3.435-1.362 4.685 4.685 0 01-.921-3.365z"
      />
    </svg>
  );
};
export const TotalCallsIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = colors.oxford } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 55.616 55.008"
      {...props}
    >
      <defs>
        <style>{`.prefix__TotalCallsIcon{fill:${fill}}`}</style>
      </defs>
      <path
        className="prefix__TotalCallsIcon"
        d="M31.728 30.163a5.032 5.032 0 01-5.027-5.027V5.027A5.032 5.032 0 0131.728 0H50.59a5.032 5.032 0 015.027 5.027v20.109a5.032 5.032 0 01-5.027 5.027zm0-26.812a1.676 1.676 0 00-1.676 1.676v20.109a1.676 1.676 0 001.676 1.676H50.59a1.676 1.676 0 001.676-1.676V5.027a1.676 1.676 0 00-1.676-1.676z"
      />
      <path
        className="prefix__TotalCallsIcon"
        d="M34.947 10.054a1.614 1.614 0 01-1.543-1.675 1.614 1.614 0 011.543-1.676h12.344a1.614 1.614 0 011.543 1.676 1.614 1.614 0 01-1.543 1.676zM34.947 17.127a1.614 1.614 0 01-1.543-1.675 1.614 1.614 0 011.543-1.676h12.344a1.614 1.614 0 011.543 1.676 1.614 1.614 0 01-1.543 1.676zM34.884 24.014a1.676 1.676 0 010-3.351h5.024a1.676 1.676 0 010 3.351zM34.521 55.008a12.248 12.248 0 01-6.589-1.935l-.063-.042a95.974 95.974 0 01-25.9-25.9 12.185 12.185 0 011.629-15.29l1.468-1.468a5.254 5.254 0 017.417 0l6.181 6.181a5.247 5.247 0 010 7.419 1.747 1.747 0 000 2.468l9.887 9.89a1.751 1.751 0 002.473 0 5.252 5.252 0 017.417 0l6.184 6.179a5.247 5.247 0 010 7.419l-1.466 1.466a12.184 12.184 0 01-8.638 3.613zM8.775 12.335a1.741 1.741 0 00-1.235.51l-1.468 1.468a8.687 8.687 0 00-1.193 10.876 92.367 92.367 0 0024.948 24.946l.023.019.023.016a8.673 8.673 0 0010.815-1.24l1.464-1.466a1.747 1.747 0 000-2.471l-6.184-6.181a1.749 1.749 0 00-2.473 0 5.259 5.259 0 01-7.419 0l-9.887-9.892a5.247 5.247 0 010-7.414 1.751 1.751 0 000-2.473l-6.184-6.181a1.742 1.742 0 00-1.23-.517z"
      />
    </svg>
  );
};
export const CopyFilledCustomIcon = (props: IconProps) => {
  const { size = defaultIconSize, fill = theme.palette.grey[600] } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={size} width={size} {...props}>
      <defs>
        <style>{`.prefix__CopyFilledCustomIcon{fill:${fill}}`}</style>
      </defs>
      <path
        className="prefix__CopyFilledCustomIcon"
        d="M16.414 1H9a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V5.586zM15 7V2l5 5z"
      />
      <path className="prefix__CopyFilledCustomIcon" d="M5 5H3v16a2 2 0 002 2h12v-2H5z" />
    </svg>
  );
};
